(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7ff4"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7ff4"] = parcelRequire;
}
parcelRequire.register("9Rgu7", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $72d5d9d85a055a69$export$6503ec6e8aabbaf; }, function (v) { return $72d5d9d85a055a69$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $72d5d9d85a055a69$export$f7ad0328861e2f03; }, function (v) { return $72d5d9d85a055a69$export$f7ad0328861e2f03 = v; });
var $72d5d9d85a055a69$export$6503ec6e8aabbaf;
var $72d5d9d85a055a69$export$f7ad0328861e2f03;
"use strict";
var $72d5d9d85a055a69$var$mapping = {};
function $72d5d9d85a055a69$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$72d5d9d85a055a69$var$mapping[keys[i]] = pairs[keys[i]];
}
function $72d5d9d85a055a69$var$resolve(id) {
    var resolved = $72d5d9d85a055a69$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$72d5d9d85a055a69$export$6503ec6e8aabbaf = $72d5d9d85a055a69$var$register;
$72d5d9d85a055a69$export$f7ad0328861e2f03 = $72d5d9d85a055a69$var$resolve;

});

parcelRequire.register("8KJLc", function(module, exports) {

$parcel$export(module.exports, "inView", function () { return $65f61da4f7f47677$export$acb1e9cb9ce4ca56; });

var $kqd0U = parcelRequire("kqd0U");

var $9Gaz0 = parcelRequire("9Gaz0");
const $65f61da4f7f47677$var$thresholds = {
    any: 0,
    all: 1
};
function $65f61da4f7f47677$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root , margin: rootMargin , amount: amount = "any"  } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */ if (typeof IntersectionObserver === "undefined") return ()=>{};
    const elements = (0, $kqd0U.resolveElements)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if ((0, $9Gaz0.isFunction)(newOnEnd)) activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $65f61da4f7f47677$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}

});
parcelRequire.register("kqd0U", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $ede0549c6b5c7395$export$90ceba2564a894f8; });
function $ede0549c6b5c7395$export$90ceba2564a894f8(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}

});

parcelRequire.register("9Gaz0", function(module, exports) {

$parcel$export(module.exports, "isFunction", function () { return $70c03b065bea8005$export$f6e2535fb5126e54; });
const $70c03b065bea8005$export$f6e2535fb5126e54 = (value)=>typeof value === "function";

});


parcelRequire.register("bwojW", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $86358c73c1ec4ed6$export$e3607ec2d7a891c4; });

var $04fAu = parcelRequire("04fAu");
var $et9TO = parcelRequire("et9TO");

var $9Gaz0 = parcelRequire("9Gaz0");

var $5dQbc = parcelRequire("5dQbc");
function $86358c73c1ec4ed6$export$290670472807ab5b(target, options = {}) {
    return (0, $et9TO.withControls)([
        ()=>{
            const animation = new (0, $5dQbc.Animation)(target, [
                0,
                1
            ], options);
            animation.finished.catch(()=>{});
            return animation;
        }
    ], options, options.duration);
}
function $86358c73c1ec4ed6$export$e3607ec2d7a891c4(target, keyframesOrOptions, options) {
    const factory = (0, $9Gaz0.isFunction)(target) ? $86358c73c1ec4ed6$export$290670472807ab5b : (0, $04fAu.animate);
    return factory(target, keyframesOrOptions, options);
}

});
parcelRequire.register("04fAu", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $00cc772ea470de50$export$e3607ec2d7a891c4; });

var $5dQbc = parcelRequire("5dQbc");

var $lyr7b = parcelRequire("lyr7b");
const $00cc772ea470de50$export$e3607ec2d7a891c4 = (0, $lyr7b.createAnimate)((0, $5dQbc.Animation));

});
parcelRequire.register("5dQbc", function(module, exports) {

$parcel$export(module.exports, "Animation", function () { return $3cd6a46c50e6290b$export$c35d437ae5945fcd; });

var $dNL5b = parcelRequire("dNL5b");
var $2MHqZ = parcelRequire("2MHqZ");
var $2g4we = parcelRequire("2g4we");
var $awXa7 = parcelRequire("awXa7");
var $k5N1q = parcelRequire("k5N1q");

var $3G2i0 = parcelRequire("3G2i0");
class $3cd6a46c50e6290b$export$c35d437ae5945fcd {
    constructor(output, keyframes = [
        0,
        1
    ], { easing: easing , duration: initialDuration = (0, $dNL5b.defaults).duration , delay: delay = (0, $dNL5b.defaults).delay , endDelay: endDelay = (0, $dNL5b.defaults).endDelay , repeat: repeat = (0, $dNL5b.defaults).repeat , offset: offset , direction: direction = "normal" , autoplay: autoplay = true  } = {}){
        this.startTime = null;
        this.rate = 1;
        this.t = 0;
        this.cancelTimestamp = null;
        this.easing = (0, $k5N1q.noopReturn);
        this.duration = 0;
        this.totalDuration = 0;
        this.repeat = 0;
        this.playState = "idle";
        this.finished = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
        easing = easing || (0, $dNL5b.defaults).easing;
        if ((0, $2g4we.isEasingGenerator)(easing)) {
            const custom = easing.createAnimation(keyframes);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            initialDuration = custom.duration || initialDuration;
        }
        this.repeat = repeat;
        this.easing = (0, $awXa7.isEasingList)(easing) ? (0, $k5N1q.noopReturn) : (0, $3G2i0.getEasingFunction)(easing);
        this.updateDuration(initialDuration);
        const interpolate$1 = (0, $2MHqZ.interpolate)(keyframes, offset, (0, $awXa7.isEasingList)(easing) ? easing.map((0, $3G2i0.getEasingFunction)) : (0, $k5N1q.noopReturn));
        this.tick = (timestamp)=>{
            var _a;
            delay;
            let t = 0;
            if (this.pauseTime !== undefined) t = this.pauseTime;
            else t = (timestamp - this.startTime) * this.rate;
            this.t = t;
            // Convert to seconds
            t /= 1000;
            // Rebase on delay
            t = Math.max(t - delay, 0);
            /**
             * If this animation has finished, set the current time
             * to the total duration.
             */ if (this.playState === "finished" && this.pauseTime === undefined) t = this.totalDuration;
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = t / this.duration;
            // TODO progress += iterationStart
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            if (!iterationProgress && progress >= 1) iterationProgress = 1;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ iterationProgress === 1 && currentIteration--;
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = currentIteration % 2;
            if (direction === "reverse" || direction === "alternate" && iterationIsOdd || direction === "alternate-reverse" && !iterationIsOdd) iterationProgress = 1 - iterationProgress;
            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
            const latest = interpolate$1(this.easing(p));
            output(latest);
            const isAnimationFinished = this.pauseTime === undefined && (this.playState === "finished" || t >= this.totalDuration + endDelay);
            if (isAnimationFinished) {
                this.playState = "finished";
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, latest);
            } else if (this.playState !== "idle") this.frameRequestId = requestAnimationFrame(this.tick);
        };
        if (autoplay) this.play();
    }
    play() {
        const now = performance.now();
        this.playState = "running";
        if (this.pauseTime !== undefined) this.startTime = now - this.pauseTime;
        else if (!this.startTime) this.startTime = now;
        this.cancelTimestamp = this.startTime;
        this.pauseTime = undefined;
        this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
        this.playState = "paused";
        this.pauseTime = this.t;
    }
    finish() {
        this.playState = "finished";
        this.tick(0);
    }
    stop() {
        var _a;
        this.playState = "idle";
        if (this.frameRequestId !== undefined) cancelAnimationFrame(this.frameRequestId);
        (_a = this.reject) === null || _a === void 0 || _a.call(this, false);
    }
    cancel() {
        this.stop();
        this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() {}
    updateDuration(duration) {
        this.duration = duration;
        this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        if (this.pauseTime !== undefined || this.rate === 0) this.pauseTime = t;
        else this.startTime = performance.now() - t / this.rate;
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(rate) {
        this.rate = rate;
    }
}

});
parcelRequire.register("dNL5b", function(module, exports) {

$parcel$export(module.exports, "defaults", function () { return $a0c45f93aa9e01a0$export$ebe90cb607ad99e; });
const $a0c45f93aa9e01a0$export$ebe90cb607ad99e = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease"
};

});

parcelRequire.register("2MHqZ", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $2071c1a08ec7719e$export$89e29e4ab65e70a9; });

var $uRDjj = parcelRequire("uRDjj");

var $k5N1q = parcelRequire("k5N1q");

var $5sHEg = parcelRequire("5sHEg");

var $geNSS = parcelRequire("geNSS");

var $2BiSR = parcelRequire("2BiSR");

var $giSNV = parcelRequire("giSNV");
function $2071c1a08ec7719e$export$89e29e4ab65e70a9(output, input = (0, $5sHEg.defaultOffset)(output.length), easing = (0, $k5N1q.noopReturn)) {
    const length = output.length;
    /**
     * If the input length is lower than the output we
     * fill the input to match. This currently assumes the input
     * is an animation progress value so is a good candidate for
     * moving outside the function.
     */ const remainder = length - input.length;
    remainder > 0 && (0, $5sHEg.fillOffset)(input, remainder);
    return (t)=>{
        let i = 0;
        for(; i < length - 2; i++){
            if (t < input[i + 1]) break;
        }
        let progressInRange = (0, $giSNV.clamp)(0, 1, (0, $geNSS.progress)(input[i], input[i + 1], t));
        const segmentEasing = (0, $2BiSR.getEasingForSegment)(easing, i);
        progressInRange = segmentEasing(progressInRange);
        return (0, $uRDjj.mix)(output[i], output[i + 1], progressInRange);
    };
}

});
parcelRequire.register("uRDjj", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $05cc67dc79851f96$export$2c9e8a9632a706b2; });
const $05cc67dc79851f96$export$2c9e8a9632a706b2 = (min, max, progress)=>-progress * min + progress * max + min;

});

parcelRequire.register("k5N1q", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $ea0a4d00e23128ac$export$8793edee2d425525; });
$parcel$export(module.exports, "noopReturn", function () { return $ea0a4d00e23128ac$export$ea6e51872ab1b721; });
const $ea0a4d00e23128ac$export$8793edee2d425525 = ()=>{};
const $ea0a4d00e23128ac$export$ea6e51872ab1b721 = (v)=>v;

});

parcelRequire.register("5sHEg", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $3fa16cf75df521a7$export$dafee61230cf05c6; });
$parcel$export(module.exports, "defaultOffset", function () { return $3fa16cf75df521a7$export$24dbcec0b26e6d9d; });

var $uRDjj = parcelRequire("uRDjj");

var $geNSS = parcelRequire("geNSS");
function $3fa16cf75df521a7$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $geNSS.progress)(0, remaining, i);
        offset.push((0, $uRDjj.mix)(min, 1, offsetProgress));
    }
}
function $3fa16cf75df521a7$export$24dbcec0b26e6d9d(length) {
    const offset = [
        0
    ];
    $3fa16cf75df521a7$export$dafee61230cf05c6(offset, length - 1);
    return offset;
}

});
parcelRequire.register("geNSS", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $bd24a616c5b5b825$export$504d7abb21fa8c9; });
const $bd24a616c5b5b825$export$504d7abb21fa8c9 = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);

});


parcelRequire.register("2BiSR", function(module, exports) {

$parcel$export(module.exports, "getEasingForSegment", function () { return $1e4daf6a2f3c782f$export$41c5e731255a462; });

var $awXa7 = parcelRequire("awXa7");

var $1UXuD = parcelRequire("1UXuD");
function $1e4daf6a2f3c782f$export$41c5e731255a462(easing, i) {
    return (0, $awXa7.isEasingList)(easing) ? easing[(0, $1UXuD.wrap)(0, easing.length, i)] : easing;
}

});
parcelRequire.register("awXa7", function(module, exports) {

$parcel$export(module.exports, "isEasingList", function () { return $7aaac8e7716d6738$export$981cc9ef33696dc8; });

var $50VeR = parcelRequire("50VeR");
const $7aaac8e7716d6738$export$981cc9ef33696dc8 = (easing)=>Array.isArray(easing) && !(0, $50VeR.isNumber)(easing[0]);

});
parcelRequire.register("50VeR", function(module, exports) {

$parcel$export(module.exports, "isNumber", function () { return $3a695a3cd0ad0ad9$export$7e4aa119212bc614; });
const $3a695a3cd0ad0ad9$export$7e4aa119212bc614 = (value)=>typeof value === "number";

});


parcelRequire.register("1UXuD", function(module, exports) {

$parcel$export(module.exports, "wrap", function () { return $16592b7f8b82343d$export$4997ffc0176396a6; });
const $16592b7f8b82343d$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};

});


parcelRequire.register("giSNV", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $bde8d6c90d366cf7$export$7d15b64cf5a3a4c4; });
const $bde8d6c90d366cf7$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);

});


parcelRequire.register("2g4we", function(module, exports) {

$parcel$export(module.exports, "isEasingGenerator", function () { return $1a5094c205e7c835$export$d81a3021299cadf2; });
const $1a5094c205e7c835$export$d81a3021299cadf2 = (easing)=>typeof easing === "object" && Boolean(easing.createAnimation);

});

parcelRequire.register("3G2i0", function(module, exports) {

$parcel$export(module.exports, "getEasingFunction", function () { return $2ad711f32a07dda5$export$9681b459c1c8f0f4; });

var $fDGFg = parcelRequire("fDGFg");
var $j7Nsh = parcelRequire("j7Nsh");

var $VXdwr = parcelRequire("VXdwr");
var $9Gaz0 = parcelRequire("9Gaz0");
var $k5N1q = parcelRequire("k5N1q");
const $2ad711f32a07dda5$var$namedEasings = {
    ease: (0, $fDGFg.cubicBezier)(0.25, 0.1, 0.25, 1.0),
    "ease-in": (0, $fDGFg.cubicBezier)(0.42, 0.0, 1.0, 1.0),
    "ease-in-out": (0, $fDGFg.cubicBezier)(0.42, 0.0, 0.58, 1.0),
    "ease-out": (0, $fDGFg.cubicBezier)(0.0, 0.0, 0.58, 1.0)
};
const $2ad711f32a07dda5$var$functionArgsRegex = /\((.*?)\)/;
function $2ad711f32a07dda5$export$9681b459c1c8f0f4(definition) {
    // If already an easing function, return
    if ((0, $9Gaz0.isFunction)(definition)) return definition;
    // If an easing curve definition, return bezier function
    if ((0, $VXdwr.isCubicBezier)(definition)) return (0, $fDGFg.cubicBezier)(...definition);
    // If we have a predefined easing function, return
    if ($2ad711f32a07dda5$var$namedEasings[definition]) return $2ad711f32a07dda5$var$namedEasings[definition];
    // If this is a steps function, attempt to create easing curve
    if (definition.startsWith("steps")) {
        const args = $2ad711f32a07dda5$var$functionArgsRegex.exec(definition);
        if (args) {
            const argsArray = args[1].split(",");
            return (0, $j7Nsh.steps)(parseFloat(argsArray[0]), argsArray[1].trim());
        }
    }
    return 0, $k5N1q.noopReturn;
}

});
parcelRequire.register("fDGFg", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $b62b97ceaf3a8063$export$2c575fa1d20488bd; });

var $k5N1q = parcelRequire("k5N1q");
/*
  Bezier function generator

  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.

  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.

  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $b62b97ceaf3a8063$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $b62b97ceaf3a8063$var$subdivisionPrecision = 0.0000001;
const $b62b97ceaf3a8063$var$subdivisionMaxIterations = 12;
function $b62b97ceaf3a8063$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $b62b97ceaf3a8063$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $b62b97ceaf3a8063$var$subdivisionPrecision && ++i < $b62b97ceaf3a8063$var$subdivisionMaxIterations);
    return currentT;
}
function $b62b97ceaf3a8063$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $k5N1q.noopReturn;
    const getTForX = (aX)=>$b62b97ceaf3a8063$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $b62b97ceaf3a8063$var$calcBezier(getTForX(t), mY1, mY2);
}

});

parcelRequire.register("j7Nsh", function(module, exports) {

$parcel$export(module.exports, "steps", function () { return $dec50887ccaa19c0$export$be3f796aed065412; });

var $giSNV = parcelRequire("giSNV");
const $dec50887ccaa19c0$export$be3f796aed065412 = (steps, direction = "end")=>(progress)=>{
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        const expanded = progress * steps;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return (0, $giSNV.clamp)(0, 1, rounded / steps);
    };

});

parcelRequire.register("VXdwr", function(module, exports) {

$parcel$export(module.exports, "isCubicBezier", function () { return $0ae34244c8134471$export$77290801a62f77a2; });

var $50VeR = parcelRequire("50VeR");
const $0ae34244c8134471$export$77290801a62f77a2 = (easing)=>Array.isArray(easing) && (0, $50VeR.isNumber)(easing[0]);

});



parcelRequire.register("lyr7b", function(module, exports) {

$parcel$export(module.exports, "createAnimate", function () { return $fb11ce5ed71fe3cb$export$2a47ca22dbf0bb08; });

var $ck5Qh = parcelRequire("ck5Qh");

var $44w9N = parcelRequire("44w9N");

var $inIS9 = parcelRequire("inIS9");

var $kqd0U = parcelRequire("kqd0U");

var $et9TO = parcelRequire("et9TO");

var $4qnBj = parcelRequire("4qnBj");
function $fb11ce5ed71fe3cb$export$2a47ca22dbf0bb08(AnimatePolyfill) {
    return function animate(elements, keyframes, options = {}) {
        elements = (0, $kqd0U.resolveElements)(elements);
        const numElements = elements.length;
        (0, $ck5Qh.invariant)(Boolean(numElements), "No valid element provided.");
        (0, $ck5Qh.invariant)(Boolean(keyframes), "No keyframes defined.");
        /**
         * Create and start new animations
         */ const animationFactories = [];
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            for(const key in keyframes){
                const valueOptions = (0, $inIS9.getOptions)(options, key);
                valueOptions.delay = (0, $4qnBj.resolveOption)(valueOptions.delay, i, numElements);
                const animation = (0, $44w9N.animateStyle)(element, key, keyframes[key], valueOptions, AnimatePolyfill);
                animationFactories.push(animation);
            }
        }
        return (0, $et9TO.withControls)(animationFactories, options, /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */ options.duration);
    };
}

});
parcelRequire.register("ck5Qh", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $8f8be2728086b007$export$f5708dca728d7177; });
var $8f8be2728086b007$export$491112666e282270 = function() {};
var $8f8be2728086b007$export$f5708dca728d7177 = function() {};

});

parcelRequire.register("44w9N", function(module, exports) {

$parcel$export(module.exports, "animateStyle", function () { return $2f707adae652b8f3$export$c76cd972d26986f9; });

var $bn4oE = parcelRequire("bn4oE");

var $3c05e = parcelRequire("3c05e");

var $dNL5b = parcelRequire("dNL5b");
var $2g4we = parcelRequire("2g4we");
var $awXa7 = parcelRequire("awXa7");
var $9Gaz0 = parcelRequire("9Gaz0");
var $50VeR = parcelRequire("50VeR");
var $k5N1q = parcelRequire("k5N1q");
var $2V20F = parcelRequire("2V20F");

var $78feT = parcelRequire("78feT");

var $dPK7D = parcelRequire("dPK7D");

var $eybLH = parcelRequire("eybLH");

var $kG62X = parcelRequire("kG62X");

var $44EMD = parcelRequire("44EMD");

var $c7xeM = parcelRequire("c7xeM");

var $89SHl = parcelRequire("89SHl");

var $h8KZD = parcelRequire("h8KZD");
function $2f707adae652b8f3$var$getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function $2f707adae652b8f3$export$c76cd972d26986f9(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = $2f707adae652b8f3$var$getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration: duration = (0, $dNL5b.defaults).duration , delay: delay = (0, $dNL5b.defaults).delay , endDelay: endDelay = (0, $dNL5b.defaults).endDelay , repeat: repeat = (0, $dNL5b.defaults).repeat , easing: easing = (0, $dNL5b.defaults).easing , persist: persist = false , direction: direction , offset: offset , allowWebkitAcceleration: allowWebkitAcceleration = false , autoplay: autoplay = true  } = options;
    const data = (0, $bn4oE.getAnimationData)(element);
    const valueIsTransform = (0, $78feT.isTransform)(key);
    let canAnimateNatively = (0, $eybLH.supports).waapi();
    /**
     * If this is an individual transform, we need to map its
     * key to a CSS variable and update the element's transform style
     */ valueIsTransform && (0, $78feT.addTransformToElement)(element, key);
    const name = (0, $c7xeM.getStyleName)(key);
    const motionValue = (0, $bn4oE.getMotionValue)(data.values, name);
    /**
     * Get definition of value, this will be used to convert numerical
     * keyframes into the default value type.
     */ const definition = (0, $78feT.transformDefinitions).get(name);
    /**
     * Stop the current animation, if any. Because this will trigger
     * commitStyles (DOM writes) and we might later trigger DOM reads,
     * this is fired now and we return a factory function to create
     * the actual animation that can get called in batch,
     */ (0, $89SHl.stopAnimation)(motionValue.animation, !((0, $2g4we.isEasingGenerator)(easing) && motionValue.generator) && options.record !== false);
    /**
     * Batchable factory function containing all DOM reads.
     */ return ()=>{
        const readInitialValue = ()=>{
            var _a, _b;
            return (_b = (_a = (0, $44EMD.style).get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0;
        };
        /**
         * Replace null values with the previous keyframe value, or read
         * it from the DOM if it's the first keyframe.
         */ let keyframes = (0, $kG62X.hydrateKeyframes)((0, $kG62X.keyframesList)(keyframesDefinition), readInitialValue);
        /**
         * Detect unit type of keyframes.
         */ const toUnit = (0, $h8KZD.getUnitConverter)(keyframes, definition);
        if ((0, $2g4we.isEasingGenerator)(easing)) {
            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            duration = custom.duration || duration;
        }
        /**
         * If this is a CSS variable we need to register it with the browser
         * before it can be animated natively. We also set it with setProperty
         * rather than directly onto the element.style object.
         */ if ((0, $3c05e.isCssVar)(name)) {
            if ((0, $eybLH.supports).cssRegisterProperty()) (0, $3c05e.registerCssVariable)(name);
            else canAnimateNatively = false;
        }
        /**
         * If we've been passed a custom easing function, and this browser
         * does **not** support linear() easing, and the value is a transform
         * (and thus a pure number) we can still support the custom easing
         * by falling back to the animation polyfill.
         */ if (valueIsTransform && !(0, $eybLH.supports).linearEasing() && ((0, $9Gaz0.isFunction)(easing) || (0, $awXa7.isEasingList)(easing) && easing.some((0, $9Gaz0.isFunction)))) canAnimateNatively = false;
        /**
         * If we can animate this value with WAAPI, do so.
         */ if (canAnimateNatively) {
            /**
             * Convert numbers to default value types. Currently this only supports
             * transforms but it could also support other value types.
             */ if (definition) keyframes = keyframes.map((value)=>(0, $50VeR.isNumber)(value) ? definition.toDefaultUnit(value) : value);
            /**
             * If this browser doesn't support partial/implicit keyframes we need to
             * explicitly provide one.
             */ if (keyframes.length === 1 && (!(0, $eybLH.supports).partialKeyframes() || isRecording)) keyframes.unshift(readInitialValue());
            const animationOptions = {
                delay: (0, $2V20F.time).ms(delay),
                duration: (0, $2V20F.time).ms(duration),
                endDelay: (0, $2V20F.time).ms(endDelay),
                easing: !(0, $awXa7.isEasingList)(easing) ? (0, $dPK7D.convertEasing)(easing, duration) : undefined,
                direction: direction,
                iterations: repeat + 1,
                fill: "both"
            };
            animation = element.animate({
                [name]: keyframes,
                offset: offset,
                easing: (0, $awXa7.isEasingList)(easing) ? easing.map((thisEasing)=>(0, $dPK7D.convertEasing)(thisEasing, duration)) : undefined
            }, animationOptions);
            /**
             * Polyfill finished Promise in browsers that don't support it
             */ if (!animation.finished) animation.finished = new Promise((resolve, reject)=>{
                animation.onfinish = resolve;
                animation.oncancel = reject;
            });
            const target = keyframes[keyframes.length - 1];
            animation.finished.then(()=>{
                if (persist) return;
                // Apply styles to target
                (0, $44EMD.style).set(element, name, target);
                // Ensure fill modes don't persist
                animation.cancel();
            }).catch((0, $k5N1q.noop));
            /**
             * This forces Webkit to run animations on the main thread by exploiting
             * this condition:
             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
             *
             * This fixes Webkit's timing bugs, like accelerated animations falling
             * out of sync with main thread animations and massive delays in starting
             * accelerated animations in WKWebView.
             */ if (!allowWebkitAcceleration) animation.playbackRate = 1.000001;
        /**
             * If we can't animate the value natively then we can fallback to the numbers-only
             * polyfill for transforms.
             */ } else if (AnimationPolyfill && valueIsTransform) {
            /**
             * If any keyframe is a string (because we measured it from the DOM), we need to convert
             * it into a number before passing to the Animation polyfill.
             */ keyframes = keyframes.map((value)=>typeof value === "string" ? parseFloat(value) : value);
            /**
             * If we only have a single keyframe, we need to create an initial keyframe by reading
             * the current value from the DOM.
             */ if (keyframes.length === 1) keyframes.unshift(parseFloat(readInitialValue()));
            animation = new AnimationPolyfill((latest)=>{
                (0, $44EMD.style).set(element, name, toUnit ? toUnit(latest) : latest);
            }, keyframes, Object.assign(Object.assign({}, options), {
                duration: duration,
                easing: easing
            }));
        } else {
            const target = keyframes[keyframes.length - 1];
            (0, $44EMD.style).set(element, name, definition && (0, $50VeR.isNumber)(target) ? definition.toDefaultUnit(target) : target);
        }
        if (isRecording) record(element, key, keyframes, {
            duration: duration,
            delay: delay,
            easing: easing,
            repeat: repeat,
            offset: offset
        }, "motion-one");
        motionValue.setAnimation(animation);
        if (animation && !autoplay) animation.pause();
        return animation;
    };
}

});
parcelRequire.register("bn4oE", function(module, exports) {

$parcel$export(module.exports, "getAnimationData", function () { return $847540c64bd59a15$export$213eea93596b44f; });
$parcel$export(module.exports, "getMotionValue", function () { return $847540c64bd59a15$export$c0999ba824977ca6; });

var $dBjvJ = parcelRequire("dBjvJ");
const $847540c64bd59a15$var$data = new WeakMap();
function $847540c64bd59a15$export$213eea93596b44f(element) {
    if (!$847540c64bd59a15$var$data.has(element)) $847540c64bd59a15$var$data.set(element, {
        transforms: [],
        values: new Map()
    });
    return $847540c64bd59a15$var$data.get(element);
}
function $847540c64bd59a15$export$c0999ba824977ca6(motionValues, name) {
    if (!motionValues.has(name)) motionValues.set(name, new (0, $dBjvJ.MotionValue)());
    return motionValues.get(name);
}

});
parcelRequire.register("dBjvJ", function(module, exports) {

$parcel$export(module.exports, "MotionValue", function () { return $9e6ddd82bd498131$export$8cea36d14ee64562; });
/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */ class $9e6ddd82bd498131$export$8cea36d14ee64562 {
    setAnimation(animation) {
        this.animation = animation;
        animation === null || animation === void 0 || animation.finished.then(()=>this.clearAnimation()).catch(()=>{});
    }
    clearAnimation() {
        this.animation = this.generator = undefined;
    }
}

});


parcelRequire.register("3c05e", function(module, exports) {

$parcel$export(module.exports, "isCssVar", function () { return $25328ea7127fba27$export$30a9abfd5fb9f5f6; });
$parcel$export(module.exports, "registerCssVariable", function () { return $25328ea7127fba27$export$9fdd8c2f6f59adb0; });

var $78feT = parcelRequire("78feT");
const $25328ea7127fba27$export$30a9abfd5fb9f5f6 = (name)=>name.startsWith("--");
const $25328ea7127fba27$export$7a740cb9e3dd106d = new Set();
function $25328ea7127fba27$export$9fdd8c2f6f59adb0(name) {
    if ($25328ea7127fba27$export$7a740cb9e3dd106d.has(name)) return;
    $25328ea7127fba27$export$7a740cb9e3dd106d.add(name);
    try {
        const { syntax: syntax , initialValue: initialValue  } = (0, $78feT.transformDefinitions).has(name) ? (0, $78feT.transformDefinitions).get(name) : {};
        CSS.registerProperty({
            name: name,
            inherits: false,
            syntax: syntax,
            initialValue: initialValue
        });
    } catch (e) {}
}

});
parcelRequire.register("78feT", function(module, exports) {

$parcel$export(module.exports, "transformAlias", function () { return $531519f753e93d62$export$97b5d3c90609c212; });
$parcel$export(module.exports, "transformDefinitions", function () { return $531519f753e93d62$export$a9dad2abc3d443d; });
$parcel$export(module.exports, "asTransformCssVar", function () { return $531519f753e93d62$export$7bbd29b1fa8b68d4; });
$parcel$export(module.exports, "isTransform", function () { return $531519f753e93d62$export$8a546e9da811625d; });
$parcel$export(module.exports, "addTransformToElement", function () { return $531519f753e93d62$export$40eba1f1af915c93; });

var $hsXm3 = parcelRequire("hsXm3");
var $k5N1q = parcelRequire("k5N1q");

var $bn4oE = parcelRequire("bn4oE");
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ const $531519f753e93d62$export$a9a762b9618d4a18 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ const $531519f753e93d62$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
const $531519f753e93d62$export$97b5d3c90609c212 = {
    x: "translateX",
    y: "translateY",
    z: "translateZ"
};
const $531519f753e93d62$var$rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v)=>v + "deg"
};
const $531519f753e93d62$var$baseTransformProperties = {
    translate: {
        syntax: "<length-percentage>",
        initialValue: "0px",
        toDefaultUnit: (v)=>v + "px"
    },
    rotate: $531519f753e93d62$var$rotation,
    scale: {
        syntax: "<number>",
        initialValue: 1,
        toDefaultUnit: (0, $k5N1q.noopReturn)
    },
    skew: $531519f753e93d62$var$rotation
};
const $531519f753e93d62$export$a9dad2abc3d443d = new Map();
const $531519f753e93d62$export$7bbd29b1fa8b68d4 = (name)=>`--motion-${name}`;
/**
 * Generate a list of every possible transform key
 */ const $531519f753e93d62$var$transforms = [
    "x",
    "y",
    "z"
];
$531519f753e93d62$var$order.forEach((name)=>{
    $531519f753e93d62$export$a9a762b9618d4a18.forEach((axis)=>{
        $531519f753e93d62$var$transforms.push(name + axis);
        $531519f753e93d62$export$a9dad2abc3d443d.set($531519f753e93d62$export$7bbd29b1fa8b68d4(name + axis), $531519f753e93d62$var$baseTransformProperties[name]);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ const $531519f753e93d62$export$11410fe03e8c4042 = (a, b)=>$531519f753e93d62$var$transforms.indexOf(a) - $531519f753e93d62$var$transforms.indexOf(b);
/**
 * Provide a quick way to check if a string is the name of a transform
 */ const $531519f753e93d62$var$transformLookup = new Set($531519f753e93d62$var$transforms);
const $531519f753e93d62$export$8a546e9da811625d = (name)=>$531519f753e93d62$var$transformLookup.has(name);
const $531519f753e93d62$export$40eba1f1af915c93 = (element, name)=>{
    // Map x to translateX etc
    if ($531519f753e93d62$export$97b5d3c90609c212[name]) name = $531519f753e93d62$export$97b5d3c90609c212[name];
    const { transforms: transforms  } = (0, $bn4oE.getAnimationData)(element);
    (0, $hsXm3.addUniqueItem)(transforms, name);
    /**
     * TODO: An optimisation here could be to cache the transform in element data
     * and only update if this has changed.
     */ element.style.transform = $531519f753e93d62$export$785216816cb6f870(transforms);
};
const $531519f753e93d62$export$785216816cb6f870 = (transforms)=>transforms.sort($531519f753e93d62$export$11410fe03e8c4042).reduce($531519f753e93d62$var$transformListToString, "").trim();
const $531519f753e93d62$var$transformListToString = (template, name)=>`${template} ${name}(var(${$531519f753e93d62$export$7bbd29b1fa8b68d4(name)}))`;

});
parcelRequire.register("hsXm3", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $cb7317d2f0395cac$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $cb7317d2f0395cac$export$fe2d9b4e03920b4c; });
function $cb7317d2f0395cac$export$20e507e47fae79fd(array, item) {
    array.indexOf(item) === -1 && array.push(item);
}
function $cb7317d2f0395cac$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}

});



parcelRequire.register("2V20F", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $220276bd67aac05f$export$2da9be4cfdb689b1; });
const $220276bd67aac05f$export$2da9be4cfdb689b1 = {
    ms: (seconds)=>seconds * 1000,
    s: (milliseconds)=>milliseconds / 1000
};

});

parcelRequire.register("dPK7D", function(module, exports) {

$parcel$export(module.exports, "convertEasing", function () { return $a123d0a96d44eb52$export$284d1118c33f9836; });

var $dNL5b = parcelRequire("dNL5b");
var $VXdwr = parcelRequire("VXdwr");
var $9Gaz0 = parcelRequire("9Gaz0");
var $geNSS = parcelRequire("geNSS");

var $eybLH = parcelRequire("eybLH");
// Create a linear easing point for every x second
const $a123d0a96d44eb52$var$resolution = 0.015;
const $a123d0a96d44eb52$export$a74bbb7e96c8ced4 = (easing, duration)=>{
    let points = "";
    const numPoints = Math.round(duration / $a123d0a96d44eb52$var$resolution);
    for(let i = 0; i < numPoints; i++)points += easing((0, $geNSS.progress)(0, numPoints - 1, i)) + ", ";
    return points.substring(0, points.length - 2);
};
const $a123d0a96d44eb52$export$284d1118c33f9836 = (easing, duration)=>{
    if ((0, $9Gaz0.isFunction)(easing)) return (0, $eybLH.supports).linearEasing() ? `linear(${$a123d0a96d44eb52$export$a74bbb7e96c8ced4(easing, duration)})` : (0, $dNL5b.defaults).easing;
    else return (0, $VXdwr.isCubicBezier)(easing) ? $a123d0a96d44eb52$export$2523b8f0bd8f44cb(easing) : easing;
};
const $a123d0a96d44eb52$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;

});
parcelRequire.register("eybLH", function(module, exports) {

$parcel$export(module.exports, "supports", function () { return $a97d5e98515634dc$export$cde6a56f9669daf6; });
const $a97d5e98515634dc$var$testAnimation = (keyframes, options)=>document.createElement("div").animate(keyframes, options);
const $a97d5e98515634dc$var$featureTests = {
    cssRegisterProperty: ()=>typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: ()=>{
        try {
            $a97d5e98515634dc$var$testAnimation({
                opacity: [
                    1
                ]
            });
        } catch (e) {
            return false;
        }
        return true;
    },
    finished: ()=>Boolean($a97d5e98515634dc$var$testAnimation({
            opacity: [
                0,
                1
            ]
        }, {
            duration: 0.001
        }).finished),
    linearEasing: ()=>{
        try {
            $a97d5e98515634dc$var$testAnimation({
                opacity: 0
            }, {
                easing: "linear(0, 1)"
            });
        } catch (e) {
            return false;
        }
        return true;
    }
};
const $a97d5e98515634dc$var$results = {};
const $a97d5e98515634dc$export$cde6a56f9669daf6 = {};
for(const key in $a97d5e98515634dc$var$featureTests)$a97d5e98515634dc$export$cde6a56f9669daf6[key] = ()=>{
    if ($a97d5e98515634dc$var$results[key] === undefined) $a97d5e98515634dc$var$results[key] = $a97d5e98515634dc$var$featureTests[key]();
    return $a97d5e98515634dc$var$results[key];
};

});


parcelRequire.register("kG62X", function(module, exports) {

$parcel$export(module.exports, "hydrateKeyframes", function () { return $f0dc6ba379c016df$export$3d2f5b3e7004e0cf; });
$parcel$export(module.exports, "keyframesList", function () { return $f0dc6ba379c016df$export$388e66a97327a012; });
function $f0dc6ba379c016df$export$3d2f5b3e7004e0cf(keyframes, readInitialValue) {
    for(let i = 0; i < keyframes.length; i++)if (keyframes[i] === null) keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
    return keyframes;
}
const $f0dc6ba379c016df$export$388e66a97327a012 = (keyframes)=>Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];

});

parcelRequire.register("44EMD", function(module, exports) {

$parcel$export(module.exports, "style", function () { return $2f772be5b995831b$export$1d567c320f4763bc; });

var $3c05e = parcelRequire("3c05e");

var $c7xeM = parcelRequire("c7xeM");

var $78feT = parcelRequire("78feT");
const $2f772be5b995831b$export$1d567c320f4763bc = {
    get: (element, name)=>{
        name = (0, $c7xeM.getStyleName)(name);
        let value = (0, $3c05e.isCssVar)(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
        if (!value && value !== 0) {
            const definition = (0, $78feT.transformDefinitions).get(name);
            if (definition) value = definition.initialValue;
        }
        return value;
    },
    set: (element, name, value)=>{
        name = (0, $c7xeM.getStyleName)(name);
        if ((0, $3c05e.isCssVar)(name)) element.style.setProperty(name, value);
        else element.style[name] = value;
    }
};

});
parcelRequire.register("c7xeM", function(module, exports) {

$parcel$export(module.exports, "getStyleName", function () { return $8d2febbd1e9a11ac$export$b6557f397a74f857; });

var $78feT = parcelRequire("78feT");
function $8d2febbd1e9a11ac$export$b6557f397a74f857(key) {
    if ((0, $78feT.transformAlias)[key]) key = (0, $78feT.transformAlias)[key];
    return (0, $78feT.isTransform)(key) ? (0, $78feT.asTransformCssVar)(key) : key;
}

});


parcelRequire.register("89SHl", function(module, exports) {

$parcel$export(module.exports, "stopAnimation", function () { return $5f0997e1dd63e550$export$3cc6f911ef1fd837; });
function $5f0997e1dd63e550$export$3cc6f911ef1fd837(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished") return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) animation.stop();
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    } catch (e) {}
}

});

parcelRequire.register("h8KZD", function(module, exports) {

$parcel$export(module.exports, "getUnitConverter", function () { return $c7a7a2e126b0f268$export$4bcf070800a2fd35; });

var $eup42 = parcelRequire("eup42");
var $k5N1q = parcelRequire("k5N1q");
function $c7a7a2e126b0f268$export$4bcf070800a2fd35(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || (0, $k5N1q.noopReturn);
    const finalKeyframe = keyframes[keyframes.length - 1];
    if ((0, $eup42.isString)(finalKeyframe)) {
        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
        if (unit) toUnit = (value)=>value + unit;
    }
    return toUnit;
}

});
parcelRequire.register("eup42", function(module, exports) {

$parcel$export(module.exports, "isString", function () { return $a8c74f3cfd9efc38$export$844ec244b1367d54; });
const $a8c74f3cfd9efc38$export$844ec244b1367d54 = (value)=>typeof value === "string";

});



parcelRequire.register("inIS9", function(module, exports) {

$parcel$export(module.exports, "getOptions", function () { return $d61d2eb5f8289867$export$d2312e68e1f5ad00; });
const $d61d2eb5f8289867$export$d2312e68e1f5ad00 = (options, key)=>/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */ options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);

});

parcelRequire.register("et9TO", function(module, exports) {

$parcel$export(module.exports, "withControls", function () { return $a88b73e202aa058e$export$c5e4bb50450218c1; });

var $dNL5b = parcelRequire("dNL5b");
var $k5N1q = parcelRequire("k5N1q");
var $2V20F = parcelRequire("2V20F");

var $89SHl = parcelRequire("89SHl");
const $a88b73e202aa058e$var$createAnimation = (factory)=>factory();
const $a88b73e202aa058e$export$c5e4bb50450218c1 = (animationFactory, options, duration = (0, $dNL5b.defaults).duration)=>{
    return new Proxy({
        animations: animationFactory.map($a88b73e202aa058e$var$createAnimation).filter(Boolean),
        duration: duration,
        options: options
    }, $a88b73e202aa058e$export$cc1adf6fb659c762);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */ const $a88b73e202aa058e$var$getActiveAnimation = (state)=>state.animations[0];
const $a88b73e202aa058e$export$cc1adf6fb659c762 = {
    get: (target, key)=>{
        const activeAnimation = $a88b73e202aa058e$var$getActiveAnimation(target);
        switch(key){
            case "duration":
                return target.duration;
            case "currentTime":
                return (0, $2V20F.time).s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
            case "playbackRate":
            case "playState":
                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
            case "finished":
                if (!target.finished) target.finished = Promise.all(target.animations.map($a88b73e202aa058e$var$selectFinished)).catch((0, $k5N1q.noop));
                return target.finished;
            case "stop":
                return ()=>{
                    target.animations.forEach((animation)=>(0, $89SHl.stopAnimation)(animation));
                };
            case "forEachNative":
                /**
                 * This is for internal use only, fire a callback for each
                 * underlying animation.
                 */ return (callback)=>{
                    target.animations.forEach((animation)=>callback(animation, target));
                };
            default:
                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? undefined : ()=>target.animations.forEach((animation)=>animation[key]());
        }
    },
    set: (target, key, value)=>{
        switch(key){
            case "currentTime":
                value = (0, $2V20F.time).ms(value);
            // Fall-through
            case "playbackRate":
                for(let i = 0; i < target.animations.length; i++)target.animations[i][key] = value;
                return true;
        }
        return false;
    }
};
const $a88b73e202aa058e$var$selectFinished = (animation)=>animation.finished;

});

parcelRequire.register("4qnBj", function(module, exports) {

$parcel$export(module.exports, "stagger", function () { return $338be5bfa4f189c1$export$ef0b4d89074db4d0; });
$parcel$export(module.exports, "resolveOption", function () { return $338be5bfa4f189c1$export$4cf8f03b86be8175; });

var $9Gaz0 = parcelRequire("9Gaz0");
var $50VeR = parcelRequire("50VeR");

var $3G2i0 = parcelRequire("3G2i0");
function $338be5bfa4f189c1$export$ef0b4d89074db4d0(duration = 0.1, { start: start = 0 , from: from = 0 , easing: easing  } = {}) {
    return (i, total)=>{
        const fromIndex = (0, $50VeR.isNumber)(from) ? from : $338be5bfa4f189c1$export$a7952f4918e96441(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (easing) {
            const maxDelay = total * duration;
            const easingFunction = (0, $3G2i0.getEasingFunction)(easing);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return start + delay;
    };
}
function $338be5bfa4f189c1$export$a7952f4918e96441(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function $338be5bfa4f189c1$export$4cf8f03b86be8175(option, i, total) {
    return (0, $9Gaz0.isFunction)(option) ? option(i, total) : option;
}

});




parcelRequire.register("56cRO", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $3b677e62561a8d34$export$3c9a16f847548506; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3b677e62561a8d34$var$extendStatics = function(d, b) {
    $3b677e62561a8d34$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3b677e62561a8d34$var$extendStatics(d, b);
};
function $3b677e62561a8d34$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3b677e62561a8d34$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3b677e62561a8d34$export$18ce0697a983be9b = function() {
    $3b677e62561a8d34$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3b677e62561a8d34$export$18ce0697a983be9b.apply(this, arguments);
};
function $3b677e62561a8d34$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3b677e62561a8d34$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3b677e62561a8d34$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3b677e62561a8d34$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3b677e62561a8d34$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3b677e62561a8d34$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3b677e62561a8d34$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3b677e62561a8d34$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3b677e62561a8d34$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3b677e62561a8d34$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3b677e62561a8d34$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3b677e62561a8d34$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3b677e62561a8d34$export$45d3717a4c69092e(o, m, p);
}
function $3b677e62561a8d34$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3b677e62561a8d34$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3b677e62561a8d34$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3b677e62561a8d34$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3b677e62561a8d34$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3b677e62561a8d34$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3b677e62561a8d34$export$10c90e4f7922046c(v) {
    return this instanceof $3b677e62561a8d34$export$10c90e4f7922046c ? (this.v = v, this) : new $3b677e62561a8d34$export$10c90e4f7922046c(v);
}
function $3b677e62561a8d34$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3b677e62561a8d34$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3b677e62561a8d34$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3b677e62561a8d34$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3b677e62561a8d34$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3b677e62561a8d34$export$19a8beecd37a4c45 === "function" ? $3b677e62561a8d34$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3b677e62561a8d34$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3b677e62561a8d34$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3b677e62561a8d34$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3b677e62561a8d34$export$45d3717a4c69092e(result, mod, k);
    }
    $3b677e62561a8d34$var$__setModuleDefault(result, mod);
    return result;
}
function $3b677e62561a8d34$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3b677e62561a8d34$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3b677e62561a8d34$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3b677e62561a8d34$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $3b677e62561a8d34$export$2e2bcd8739ae039 = {
    __extends: $3b677e62561a8d34$export$a8ba968b8961cb8a,
    __assign: $3b677e62561a8d34$export$18ce0697a983be9b,
    __rest: $3b677e62561a8d34$export$3c9a16f847548506,
    __decorate: $3b677e62561a8d34$export$29e00dfd3077644b,
    __param: $3b677e62561a8d34$export$d5ad3fd78186038f,
    __metadata: $3b677e62561a8d34$export$f1db080c865becb9,
    __awaiter: $3b677e62561a8d34$export$1050f835b63b671e,
    __generator: $3b677e62561a8d34$export$67ebef60e6f28a6,
    __createBinding: $3b677e62561a8d34$export$45d3717a4c69092e,
    __exportStar: $3b677e62561a8d34$export$f33643c0debef087,
    __values: $3b677e62561a8d34$export$19a8beecd37a4c45,
    __read: $3b677e62561a8d34$export$8d051b38c9118094,
    __spread: $3b677e62561a8d34$export$afc72e2116322959,
    __spreadArrays: $3b677e62561a8d34$export$6388937ca91ccae8,
    __spreadArray: $3b677e62561a8d34$export$1216008129fb82ed,
    __await: $3b677e62561a8d34$export$10c90e4f7922046c,
    __asyncGenerator: $3b677e62561a8d34$export$e427f37a30a4de9b,
    __asyncDelegator: $3b677e62561a8d34$export$bbd80228419bb833,
    __asyncValues: $3b677e62561a8d34$export$e3b29a3d6162315f,
    __makeTemplateObject: $3b677e62561a8d34$export$4fb47efe1390b86f,
    __importStar: $3b677e62561a8d34$export$c21735bcef00d192,
    __importDefault: $3b677e62561a8d34$export$da59b14a69baef04,
    __classPrivateFieldGet: $3b677e62561a8d34$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3b677e62561a8d34$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3b677e62561a8d34$export$81fdc39f203e4e04
};

});

parcelRequire.register("dmkYV", function(module, exports) {



module.exports = (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("8oHY7")).then(()=>parcelRequire("2VwrY"));

});
parcelRequire.register("b9mAA", function(module, exports) {
"use strict";

var $5967f = parcelRequire("5967f");
module.exports = $5967f(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("5967f", function(module, exports) {
"use strict";
var $3bf28982004bcc69$var$cachedBundles = {};
var $3bf28982004bcc69$var$cachedPreloads = {};
var $3bf28982004bcc69$var$cachedPrefetches = {};
function $3bf28982004bcc69$var$getCache(type) {
    switch(type){
        case "preload":
            return $3bf28982004bcc69$var$cachedPreloads;
        case "prefetch":
            return $3bf28982004bcc69$var$cachedPrefetches;
        default:
            return $3bf28982004bcc69$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $3bf28982004bcc69$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("k9Rf3", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $eacdf29add98cd22$export$bdfd709ae4826697; }, function (v) { return $eacdf29add98cd22$export$bdfd709ae4826697 = v; });
var $eacdf29add98cd22$export$bdfd709ae4826697;
var $eacdf29add98cd22$export$c9e73fbda7da57b6;
var $eacdf29add98cd22$export$5a759dc7a1cfb72a;
"use strict";
var $eacdf29add98cd22$var$bundleURL = {};
function $eacdf29add98cd22$var$getBundleURLCached(id) {
    var value = $eacdf29add98cd22$var$bundleURL[id];
    if (!value) {
        value = $eacdf29add98cd22$var$getBundleURL();
        $eacdf29add98cd22$var$bundleURL[id] = value;
    }
    return value;
}
function $eacdf29add98cd22$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $eacdf29add98cd22$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $eacdf29add98cd22$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $eacdf29add98cd22$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$eacdf29add98cd22$export$bdfd709ae4826697 = $eacdf29add98cd22$var$getBundleURLCached;
$eacdf29add98cd22$export$c9e73fbda7da57b6 = $eacdf29add98cd22$var$getBaseURL;
$eacdf29add98cd22$export$5a759dc7a1cfb72a = $eacdf29add98cd22$var$getOrigin;

});


parcelRequire.register("dR8tM", function(module, exports) {



module.exports = (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("1T1Nu")).then(()=>parcelRequire("atnBT"));

});

parcelRequire.register("2yi0A", function(module, exports) {



module.exports = (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("8Yjk8")).then(()=>parcelRequire("6mV7H"));

});

parcelRequire.register("1aKZv", function(module, exports) {



module.exports = (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("bvh6F")).then(()=>parcelRequire("27CRG"));

});

parcelRequire.register("18V4F", function(module, exports) {



module.exports = (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("53sxr")).then(()=>parcelRequire("2ZfvF"));

});

parcelRequire.register("eL3hJ", function(module, exports) {



module.exports = (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("hLfQD")).then(()=>parcelRequire("4arg1"));

});

parcelRequire.register("coHQp", function(module, exports) {



module.exports = (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("2QUpA")).then(()=>parcelRequire("ltNrb"));

});

parcelRequire.register("8yGKq", function(module, exports) {



module.exports = (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("kKWeQ")).then(()=>parcelRequire("2KXy3"));

});

parcelRequire.register("2TxWE", function(module, exports) {



module.exports = (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("bwpvd")).then(()=>parcelRequire("88XKh"));

});

parcelRequire.register("9FRWQ", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("kbefT"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("ahsQy")),
    (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("1bTvf"))
]).then(()=>parcelRequire("aVMxD"));

});
parcelRequire.register("kbefT", function(module, exports) {
"use strict";

var $5967f = parcelRequire("5967f");
module.exports = $5967f(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});


parcelRequire.register("cc94P", function(module, exports) {



module.exports = (parcelRequire("b9mAA"))((parcelRequire("k9Rf3")).getBundleURL("3N9Uo") + (parcelRequire("9Rgu7")).resolve("c9nOE")).then(()=>parcelRequire("cRje4"));

});

var $6992ba41a945714a$exports = {};

(parcelRequire("9Rgu7")).register(JSON.parse('{"3N9Uo":"main.js","8oHY7":"banner.3a95abf5.js","1T1Nu":"full-image-banner.b5e1ee83.js","8Yjk8":"simple-header.b57bb642.js","bvh6F":"hero.0d81816c.js","53sxr":"marquee.8233e126.js","hLfQD":"countup.7ea9d6dc.js","2QUpA":"fixedscroll.19187f35.js","kKWeQ":"stickystats.a4b27133.js","bwpvd":"fileUploadElement.74e25a24.js","1bTvf":"carousel.2afa5bc2.js","ahsQy":"carousel.c8c914f9.css","c9nOE":"projectslider.bcee6759.js","hsH1T":"main.css"}'));


var $8KJLc = parcelRequire("8KJLc");
// packages/alpinejs/src/scheduler.js
var $6e21d5af8b0e2b63$var$flushPending = false;
var $6e21d5af8b0e2b63$var$flushing = false;
var $6e21d5af8b0e2b63$var$queue = [];
var $6e21d5af8b0e2b63$var$lastFlushedIndex = -1;
function $6e21d5af8b0e2b63$var$scheduler(callback) {
    $6e21d5af8b0e2b63$var$queueJob(callback);
}
function $6e21d5af8b0e2b63$var$queueJob(job) {
    if (!$6e21d5af8b0e2b63$var$queue.includes(job)) $6e21d5af8b0e2b63$var$queue.push(job);
    $6e21d5af8b0e2b63$var$queueFlush();
}
function $6e21d5af8b0e2b63$var$dequeueJob(job) {
    let index = $6e21d5af8b0e2b63$var$queue.indexOf(job);
    if (index !== -1 && index > $6e21d5af8b0e2b63$var$lastFlushedIndex) $6e21d5af8b0e2b63$var$queue.splice(index, 1);
}
function $6e21d5af8b0e2b63$var$queueFlush() {
    if (!$6e21d5af8b0e2b63$var$flushing && !$6e21d5af8b0e2b63$var$flushPending) {
        $6e21d5af8b0e2b63$var$flushPending = true;
        queueMicrotask($6e21d5af8b0e2b63$var$flushJobs);
    }
}
function $6e21d5af8b0e2b63$var$flushJobs() {
    $6e21d5af8b0e2b63$var$flushPending = false;
    $6e21d5af8b0e2b63$var$flushing = true;
    for(let i = 0; i < $6e21d5af8b0e2b63$var$queue.length; i++){
        $6e21d5af8b0e2b63$var$queue[i]();
        $6e21d5af8b0e2b63$var$lastFlushedIndex = i;
    }
    $6e21d5af8b0e2b63$var$queue.length = 0;
    $6e21d5af8b0e2b63$var$lastFlushedIndex = -1;
    $6e21d5af8b0e2b63$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $6e21d5af8b0e2b63$var$reactive;
var $6e21d5af8b0e2b63$var$effect;
var $6e21d5af8b0e2b63$var$release;
var $6e21d5af8b0e2b63$var$raw;
var $6e21d5af8b0e2b63$var$shouldSchedule = true;
function $6e21d5af8b0e2b63$var$disableEffectScheduling(callback) {
    $6e21d5af8b0e2b63$var$shouldSchedule = false;
    callback();
    $6e21d5af8b0e2b63$var$shouldSchedule = true;
}
function $6e21d5af8b0e2b63$var$setReactivityEngine(engine) {
    $6e21d5af8b0e2b63$var$reactive = engine.reactive;
    $6e21d5af8b0e2b63$var$release = engine.release;
    $6e21d5af8b0e2b63$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($6e21d5af8b0e2b63$var$shouldSchedule) $6e21d5af8b0e2b63$var$scheduler(task);
                else task();
            }
        });
    $6e21d5af8b0e2b63$var$raw = engine.raw;
}
function $6e21d5af8b0e2b63$var$overrideEffect(override) {
    $6e21d5af8b0e2b63$var$effect = override;
}
function $6e21d5af8b0e2b63$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $6e21d5af8b0e2b63$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $6e21d5af8b0e2b63$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
// packages/alpinejs/src/mutation.js
var $6e21d5af8b0e2b63$var$onAttributeAddeds = [];
var $6e21d5af8b0e2b63$var$onElRemoveds = [];
var $6e21d5af8b0e2b63$var$onElAddeds = [];
function $6e21d5af8b0e2b63$var$onElAdded(callback) {
    $6e21d5af8b0e2b63$var$onElAddeds.push(callback);
}
function $6e21d5af8b0e2b63$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $6e21d5af8b0e2b63$var$onElRemoveds.push(callback);
    }
}
function $6e21d5af8b0e2b63$var$onAttributesAdded(callback) {
    $6e21d5af8b0e2b63$var$onAttributeAddeds.push(callback);
}
function $6e21d5af8b0e2b63$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $6e21d5af8b0e2b63$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
var $6e21d5af8b0e2b63$var$observer = new MutationObserver($6e21d5af8b0e2b63$var$onMutate);
var $6e21d5af8b0e2b63$var$currentlyObserving = false;
function $6e21d5af8b0e2b63$var$startObservingMutations() {
    $6e21d5af8b0e2b63$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $6e21d5af8b0e2b63$var$currentlyObserving = true;
}
function $6e21d5af8b0e2b63$var$stopObservingMutations() {
    $6e21d5af8b0e2b63$var$flushObserver();
    $6e21d5af8b0e2b63$var$observer.disconnect();
    $6e21d5af8b0e2b63$var$currentlyObserving = false;
}
var $6e21d5af8b0e2b63$var$recordQueue = [];
var $6e21d5af8b0e2b63$var$willProcessRecordQueue = false;
function $6e21d5af8b0e2b63$var$flushObserver() {
    $6e21d5af8b0e2b63$var$recordQueue = $6e21d5af8b0e2b63$var$recordQueue.concat($6e21d5af8b0e2b63$var$observer.takeRecords());
    if ($6e21d5af8b0e2b63$var$recordQueue.length && !$6e21d5af8b0e2b63$var$willProcessRecordQueue) {
        $6e21d5af8b0e2b63$var$willProcessRecordQueue = true;
        queueMicrotask(()=>{
            $6e21d5af8b0e2b63$var$processRecordQueue();
            $6e21d5af8b0e2b63$var$willProcessRecordQueue = false;
        });
    }
}
function $6e21d5af8b0e2b63$var$processRecordQueue() {
    $6e21d5af8b0e2b63$var$onMutate($6e21d5af8b0e2b63$var$recordQueue);
    $6e21d5af8b0e2b63$var$recordQueue.length = 0;
}
function $6e21d5af8b0e2b63$var$mutateDom(callback) {
    if (!$6e21d5af8b0e2b63$var$currentlyObserving) return callback();
    $6e21d5af8b0e2b63$var$stopObservingMutations();
    let result = callback();
    $6e21d5af8b0e2b63$var$startObservingMutations();
    return result;
}
var $6e21d5af8b0e2b63$var$isCollecting = false;
var $6e21d5af8b0e2b63$var$deferredMutations = [];
function $6e21d5af8b0e2b63$var$deferMutations() {
    $6e21d5af8b0e2b63$var$isCollecting = true;
}
function $6e21d5af8b0e2b63$var$flushAndStopDeferringMutations() {
    $6e21d5af8b0e2b63$var$isCollecting = false;
    $6e21d5af8b0e2b63$var$onMutate($6e21d5af8b0e2b63$var$deferredMutations);
    $6e21d5af8b0e2b63$var$deferredMutations = [];
}
function $6e21d5af8b0e2b63$var$onMutate(mutations) {
    if ($6e21d5af8b0e2b63$var$isCollecting) {
        $6e21d5af8b0e2b63$var$deferredMutations = $6e21d5af8b0e2b63$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = new Map();
    let removedAttributes = new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.push(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.push(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $6e21d5af8b0e2b63$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $6e21d5af8b0e2b63$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.includes(node)) continue;
        $6e21d5af8b0e2b63$var$onElRemoveds.forEach((i)=>i(node));
        if (node._x_cleanups) while(node._x_cleanups.length)node._x_cleanups.pop()();
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.includes(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $6e21d5af8b0e2b63$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $6e21d5af8b0e2b63$var$scope(node) {
    return $6e21d5af8b0e2b63$var$mergeProxies($6e21d5af8b0e2b63$var$closestDataStack(node));
}
function $6e21d5af8b0e2b63$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$6e21d5af8b0e2b63$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $6e21d5af8b0e2b63$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $6e21d5af8b0e2b63$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $6e21d5af8b0e2b63$var$closestDataStack(node.parentNode);
}
function $6e21d5af8b0e2b63$var$mergeProxies(objects) {
    let thisProxy = new Proxy({}, {
        ownKeys: ()=>{
            return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
        },
        has: (target, name)=>{
            return objects.some((obj)=>obj.hasOwnProperty(name));
        },
        get: (target, name)=>{
            return (objects.find((obj)=>{
                if (obj.hasOwnProperty(name)) {
                    let descriptor = Object.getOwnPropertyDescriptor(obj, name);
                    if (descriptor.get && descriptor.get._x_alreadyBound || descriptor.set && descriptor.set._x_alreadyBound) return true;
                    if ((descriptor.get || descriptor.set) && descriptor.enumerable) {
                        let getter = descriptor.get;
                        let setter = descriptor.set;
                        let property = descriptor;
                        getter = getter && getter.bind(thisProxy);
                        setter = setter && setter.bind(thisProxy);
                        if (getter) getter._x_alreadyBound = true;
                        if (setter) setter._x_alreadyBound = true;
                        Object.defineProperty(obj, name, {
                            ...property,
                            get: getter,
                            set: setter
                        });
                    }
                    return true;
                }
                return false;
            }) || {})[name];
        },
        set: (target, name, value)=>{
            let closestObjectWithKey = objects.find((obj)=>obj.hasOwnProperty(name));
            if (closestObjectWithKey) closestObjectWithKey[name] = value;
            else objects[objects.length - 1][name] = value;
            return true;
        }
    });
    return thisProxy;
}
// packages/alpinejs/src/interceptor.js
function $6e21d5af8b0e2b63$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value , enumerable: enumerable  }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $6e21d5af8b0e2b63$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$6e21d5af8b0e2b63$var$get(data2, path), (value)=>$6e21d5af8b0e2b63$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $6e21d5af8b0e2b63$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $6e21d5af8b0e2b63$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $6e21d5af8b0e2b63$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $6e21d5af8b0e2b63$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $6e21d5af8b0e2b63$var$magics = {};
function $6e21d5af8b0e2b63$var$magic(name, callback) {
    $6e21d5af8b0e2b63$var$magics[name] = callback;
}
function $6e21d5af8b0e2b63$var$injectMagics(obj, el) {
    Object.entries($6e21d5af8b0e2b63$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $6e21d5af8b0e2b63$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $6e21d5af8b0e2b63$var$interceptor,
                    ...utilities
                };
                $6e21d5af8b0e2b63$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $6e21d5af8b0e2b63$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $6e21d5af8b0e2b63$var$handleError(e, el, expression);
    }
}
function $6e21d5af8b0e2b63$var$handleError(error2, el, expression) {
    Object.assign(error2, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $6e21d5af8b0e2b63$var$shouldAutoEvaluateFunctions = true;
function $6e21d5af8b0e2b63$var$dontAutoEvaluateFunctions(callback) {
    let cache = $6e21d5af8b0e2b63$var$shouldAutoEvaluateFunctions;
    $6e21d5af8b0e2b63$var$shouldAutoEvaluateFunctions = false;
    callback();
    $6e21d5af8b0e2b63$var$shouldAutoEvaluateFunctions = cache;
}
function $6e21d5af8b0e2b63$var$evaluate(el, expression, extras = {}) {
    let result;
    $6e21d5af8b0e2b63$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $6e21d5af8b0e2b63$var$evaluateLater(...args) {
    return $6e21d5af8b0e2b63$var$theEvaluatorFunction(...args);
}
var $6e21d5af8b0e2b63$var$theEvaluatorFunction = $6e21d5af8b0e2b63$var$normalEvaluator;
function $6e21d5af8b0e2b63$var$setEvaluator(newEvaluator) {
    $6e21d5af8b0e2b63$var$theEvaluatorFunction = newEvaluator;
}
function $6e21d5af8b0e2b63$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $6e21d5af8b0e2b63$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$6e21d5af8b0e2b63$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $6e21d5af8b0e2b63$var$generateEvaluatorFromFunction(dataStack, expression) : $6e21d5af8b0e2b63$var$generateEvaluatorFromString(dataStack, expression, el);
    return $6e21d5af8b0e2b63$var$tryCatch.bind(null, el, expression, evaluator);
}
function $6e21d5af8b0e2b63$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {} , params: params = []  } = {})=>{
        let result = func.apply($6e21d5af8b0e2b63$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $6e21d5af8b0e2b63$var$runIfTypeOfFunction(receiver, result);
    };
}
var $6e21d5af8b0e2b63$var$evaluatorMemo = {};
function $6e21d5af8b0e2b63$var$generateFunctionFromString(expression, el) {
    if ($6e21d5af8b0e2b63$var$evaluatorMemo[expression]) return $6e21d5af8b0e2b63$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression) || /^(let|const)\s/.test(expression) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            return new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
        } catch (error2) {
            $6e21d5af8b0e2b63$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $6e21d5af8b0e2b63$var$evaluatorMemo[expression] = func;
    return func;
}
function $6e21d5af8b0e2b63$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $6e21d5af8b0e2b63$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {} , params: params = []  } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $6e21d5af8b0e2b63$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$6e21d5af8b0e2b63$var$handleError(error2, el, expression));
            if (func.finished) {
                $6e21d5af8b0e2b63$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $6e21d5af8b0e2b63$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$6e21d5af8b0e2b63$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $6e21d5af8b0e2b63$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($6e21d5af8b0e2b63$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$6e21d5af8b0e2b63$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$6e21d5af8b0e2b63$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $6e21d5af8b0e2b63$var$prefixAsString = "x-";
function $6e21d5af8b0e2b63$var$prefix(subject = "") {
    return $6e21d5af8b0e2b63$var$prefixAsString + subject;
}
function $6e21d5af8b0e2b63$var$setPrefix(newPrefix) {
    $6e21d5af8b0e2b63$var$prefixAsString = newPrefix;
}
var $6e21d5af8b0e2b63$var$directiveHandlers = {};
function $6e21d5af8b0e2b63$var$directive(name, callback) {
    $6e21d5af8b0e2b63$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$6e21d5af8b0e2b63$var$directiveHandlers[directive2]) {
                console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
                return;
            }
            const pos = $6e21d5af8b0e2b63$var$directiveOrder.indexOf(directive2);
            $6e21d5af8b0e2b63$var$directiveOrder.splice(pos >= 0 ? pos : $6e21d5af8b0e2b63$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $6e21d5af8b0e2b63$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $6e21d5af8b0e2b63$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($6e21d5af8b0e2b63$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($6e21d5af8b0e2b63$var$outNonAlpineAttributes).map($6e21d5af8b0e2b63$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($6e21d5af8b0e2b63$var$byPriority);
    return directives2.map((directive2)=>{
        return $6e21d5af8b0e2b63$var$getDirectiveHandler(el, directive2);
    });
}
function $6e21d5af8b0e2b63$var$attributesOnly(attributes) {
    return Array.from(attributes).map($6e21d5af8b0e2b63$var$toTransformedAttributes()).filter((attr)=>!$6e21d5af8b0e2b63$var$outNonAlpineAttributes(attr));
}
var $6e21d5af8b0e2b63$var$isDeferringHandlers = false;
var $6e21d5af8b0e2b63$var$directiveHandlerStacks = new Map();
var $6e21d5af8b0e2b63$var$currentHandlerStackKey = Symbol();
function $6e21d5af8b0e2b63$var$deferHandlingDirectives(callback) {
    $6e21d5af8b0e2b63$var$isDeferringHandlers = true;
    let key = Symbol();
    $6e21d5af8b0e2b63$var$currentHandlerStackKey = key;
    $6e21d5af8b0e2b63$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($6e21d5af8b0e2b63$var$directiveHandlerStacks.get(key).length)$6e21d5af8b0e2b63$var$directiveHandlerStacks.get(key).shift()();
        $6e21d5af8b0e2b63$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $6e21d5af8b0e2b63$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $6e21d5af8b0e2b63$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $6e21d5af8b0e2b63$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $6e21d5af8b0e2b63$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $6e21d5af8b0e2b63$var$evaluateLater.bind($6e21d5af8b0e2b63$var$evaluateLater, el),
        evaluate: $6e21d5af8b0e2b63$var$evaluate.bind($6e21d5af8b0e2b63$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $6e21d5af8b0e2b63$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler3 = $6e21d5af8b0e2b63$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $6e21d5af8b0e2b63$var$getElementBoundUtilities(el);
    $6e21d5af8b0e2b63$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler3.inline && handler3.inline(el, directive2, utilities);
        handler3 = handler3.bind(handler3, el, directive2, utilities);
        $6e21d5af8b0e2b63$var$isDeferringHandlers ? $6e21d5af8b0e2b63$var$directiveHandlerStacks.get($6e21d5af8b0e2b63$var$currentHandlerStackKey).push(handler3) : handler3();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $6e21d5af8b0e2b63$var$startingWith = (subject, replacement)=>({ name: name , value: value  })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $6e21d5af8b0e2b63$var$into = (i)=>i;
function $6e21d5af8b0e2b63$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name , value: value  })=>{
        let { name: newName , value: newValue  } = $6e21d5af8b0e2b63$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $6e21d5af8b0e2b63$var$attributeTransformers = [];
function $6e21d5af8b0e2b63$var$mapAttributes(callback) {
    $6e21d5af8b0e2b63$var$attributeTransformers.push(callback);
}
function $6e21d5af8b0e2b63$var$outNonAlpineAttributes({ name: name  }) {
    return $6e21d5af8b0e2b63$var$alpineAttributeRegex().test(name);
}
var $6e21d5af8b0e2b63$var$alpineAttributeRegex = ()=>new RegExp(`^${$6e21d5af8b0e2b63$var$prefixAsString}([^:^.]+)\\b`);
function $6e21d5af8b0e2b63$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name , value: value  })=>{
        let typeMatch = name.match($6e21d5af8b0e2b63$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $6e21d5af8b0e2b63$var$DEFAULT = "DEFAULT";
var $6e21d5af8b0e2b63$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $6e21d5af8b0e2b63$var$DEFAULT,
    "teleport"
];
function $6e21d5af8b0e2b63$var$byPriority(a, b) {
    let typeA = $6e21d5af8b0e2b63$var$directiveOrder.indexOf(a.type) === -1 ? $6e21d5af8b0e2b63$var$DEFAULT : a.type;
    let typeB = $6e21d5af8b0e2b63$var$directiveOrder.indexOf(b.type) === -1 ? $6e21d5af8b0e2b63$var$DEFAULT : b.type;
    return $6e21d5af8b0e2b63$var$directiveOrder.indexOf(typeA) - $6e21d5af8b0e2b63$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $6e21d5af8b0e2b63$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $6e21d5af8b0e2b63$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$6e21d5af8b0e2b63$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $6e21d5af8b0e2b63$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $6e21d5af8b0e2b63$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $6e21d5af8b0e2b63$var$started = false;
function $6e21d5af8b0e2b63$var$start() {
    if ($6e21d5af8b0e2b63$var$started) $6e21d5af8b0e2b63$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $6e21d5af8b0e2b63$var$started = true;
    if (!document.body) $6e21d5af8b0e2b63$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $6e21d5af8b0e2b63$var$dispatch(document, "alpine:init");
    $6e21d5af8b0e2b63$var$dispatch(document, "alpine:initializing");
    $6e21d5af8b0e2b63$var$startObservingMutations();
    $6e21d5af8b0e2b63$var$onElAdded((el)=>$6e21d5af8b0e2b63$var$initTree(el, $6e21d5af8b0e2b63$var$walk));
    $6e21d5af8b0e2b63$var$onElRemoved((el)=>$6e21d5af8b0e2b63$var$destroyTree(el));
    $6e21d5af8b0e2b63$var$onAttributesAdded((el, attrs)=>{
        $6e21d5af8b0e2b63$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$6e21d5af8b0e2b63$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($6e21d5af8b0e2b63$var$allSelectors())).filter(outNestedComponents).forEach((el)=>{
        $6e21d5af8b0e2b63$var$initTree(el);
    });
    $6e21d5af8b0e2b63$var$dispatch(document, "alpine:initialized");
}
var $6e21d5af8b0e2b63$var$rootSelectorCallbacks = [];
var $6e21d5af8b0e2b63$var$initSelectorCallbacks = [];
function $6e21d5af8b0e2b63$var$rootSelectors() {
    return $6e21d5af8b0e2b63$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $6e21d5af8b0e2b63$var$allSelectors() {
    return $6e21d5af8b0e2b63$var$rootSelectorCallbacks.concat($6e21d5af8b0e2b63$var$initSelectorCallbacks).map((fn)=>fn());
}
function $6e21d5af8b0e2b63$var$addRootSelector(selectorCallback) {
    $6e21d5af8b0e2b63$var$rootSelectorCallbacks.push(selectorCallback);
}
function $6e21d5af8b0e2b63$var$addInitSelector(selectorCallback) {
    $6e21d5af8b0e2b63$var$initSelectorCallbacks.push(selectorCallback);
}
function $6e21d5af8b0e2b63$var$closestRoot(el, includeInitSelectors = false) {
    return $6e21d5af8b0e2b63$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $6e21d5af8b0e2b63$var$allSelectors() : $6e21d5af8b0e2b63$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $6e21d5af8b0e2b63$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $6e21d5af8b0e2b63$var$findClosest(el.parentElement, callback);
}
function $6e21d5af8b0e2b63$var$isRoot(el) {
    return $6e21d5af8b0e2b63$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $6e21d5af8b0e2b63$var$initInterceptors2 = [];
function $6e21d5af8b0e2b63$var$interceptInit(callback) {
    $6e21d5af8b0e2b63$var$initInterceptors2.push(callback);
}
function $6e21d5af8b0e2b63$var$initTree(el, walker = $6e21d5af8b0e2b63$var$walk, intercept = ()=>{}) {
    $6e21d5af8b0e2b63$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $6e21d5af8b0e2b63$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $6e21d5af8b0e2b63$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $6e21d5af8b0e2b63$var$destroyTree(root) {
    $6e21d5af8b0e2b63$var$walk(root, (el)=>$6e21d5af8b0e2b63$var$cleanupAttributes(el));
}
// packages/alpinejs/src/nextTick.js
var $6e21d5af8b0e2b63$var$tickStack = [];
var $6e21d5af8b0e2b63$var$isHolding = false;
function $6e21d5af8b0e2b63$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $6e21d5af8b0e2b63$var$isHolding || setTimeout(()=>{
            $6e21d5af8b0e2b63$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $6e21d5af8b0e2b63$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $6e21d5af8b0e2b63$var$releaseNextTicks() {
    $6e21d5af8b0e2b63$var$isHolding = false;
    while($6e21d5af8b0e2b63$var$tickStack.length)$6e21d5af8b0e2b63$var$tickStack.shift()();
}
function $6e21d5af8b0e2b63$var$holdNextTicks() {
    $6e21d5af8b0e2b63$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $6e21d5af8b0e2b63$var$setClasses(el, value) {
    if (Array.isArray(value)) return $6e21d5af8b0e2b63$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $6e21d5af8b0e2b63$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $6e21d5af8b0e2b63$var$setClasses(el, value());
    return $6e21d5af8b0e2b63$var$setClassesFromString(el, value);
}
function $6e21d5af8b0e2b63$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $6e21d5af8b0e2b63$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $6e21d5af8b0e2b63$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $6e21d5af8b0e2b63$var$setStylesFromObject(el, value);
    return $6e21d5af8b0e2b63$var$setStylesFromString(el, value);
}
function $6e21d5af8b0e2b63$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $6e21d5af8b0e2b63$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $6e21d5af8b0e2b63$var$setStyles(el, previousStyles);
    };
}
function $6e21d5af8b0e2b63$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $6e21d5af8b0e2b63$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $6e21d5af8b0e2b63$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$6e21d5af8b0e2b63$var$directive("transition", (el, { value: value , modifiers: modifiers , expression: expression  }, { evaluate: evaluate2  })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $6e21d5af8b0e2b63$var$registerTransitionsFromHelper(el, modifiers, value);
    else $6e21d5af8b0e2b63$var$registerTransitionsFromClassString(el, expression, value);
});
function $6e21d5af8b0e2b63$var$registerTransitionsFromClassString(el, classString, stage) {
    $6e21d5af8b0e2b63$var$registerTransitionObject(el, $6e21d5af8b0e2b63$var$setClasses, "");
    let directiveStorageMap = {
        enter: (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        leave: (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $6e21d5af8b0e2b63$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $6e21d5af8b0e2b63$var$registerTransitionObject(el, $6e21d5af8b0e2b63$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $6e21d5af8b0e2b63$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $6e21d5af8b0e2b63$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $6e21d5af8b0e2b63$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $6e21d5af8b0e2b63$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $6e21d5af8b0e2b63$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $6e21d5af8b0e2b63$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $6e21d5af8b0e2b63$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $6e21d5af8b0e2b63$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $6e21d5af8b0e2b63$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $6e21d5af8b0e2b63$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $6e21d5af8b0e2b63$var$closestHide(parent);
}
function $6e21d5af8b0e2b63$var$transition(el, setFunction, { during: during , start: start2 , end: end  } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $6e21d5af8b0e2b63$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $6e21d5af8b0e2b63$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $6e21d5af8b0e2b63$var$once(()=>{
        $6e21d5af8b0e2b63$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $6e21d5af8b0e2b63$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $6e21d5af8b0e2b63$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $6e21d5af8b0e2b63$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $6e21d5af8b0e2b63$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $6e21d5af8b0e2b63$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $6e21d5af8b0e2b63$var$mutateDom(()=>{
                stages.end();
            });
            $6e21d5af8b0e2b63$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $6e21d5af8b0e2b63$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $6e21d5af8b0e2b63$var$isCloning = false;
function $6e21d5af8b0e2b63$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$6e21d5af8b0e2b63$var$isCloning ? fallback(...args) : callback(...args);
}
function $6e21d5af8b0e2b63$var$onlyDuringClone(callback) {
    return (...args)=>$6e21d5af8b0e2b63$var$isCloning && callback(...args);
}
function $6e21d5af8b0e2b63$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $6e21d5af8b0e2b63$var$isCloning = true;
    $6e21d5af8b0e2b63$var$dontRegisterReactiveSideEffects(()=>{
        $6e21d5af8b0e2b63$var$cloneTree(newEl);
    });
    $6e21d5af8b0e2b63$var$isCloning = false;
}
function $6e21d5af8b0e2b63$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $6e21d5af8b0e2b63$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $6e21d5af8b0e2b63$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $6e21d5af8b0e2b63$var$initTree(el, shallowWalker);
}
function $6e21d5af8b0e2b63$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $6e21d5af8b0e2b63$var$effect;
    $6e21d5af8b0e2b63$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $6e21d5af8b0e2b63$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $6e21d5af8b0e2b63$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $6e21d5af8b0e2b63$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $6e21d5af8b0e2b63$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $6e21d5af8b0e2b63$var$camelCase(name) : name;
    switch(name){
        case "value":
            $6e21d5af8b0e2b63$var$bindInputValue(el, value);
            break;
        case "style":
            $6e21d5af8b0e2b63$var$bindStyles(el, value);
            break;
        case "class":
            $6e21d5af8b0e2b63$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $6e21d5af8b0e2b63$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $6e21d5af8b0e2b63$var$bindAttribute(el, name, value);
            break;
    }
}
function $6e21d5af8b0e2b63$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) el.checked = $6e21d5af8b0e2b63$var$checkedAttrLooseCompare(el.value, value);
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Number.isInteger(value) && !Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$6e21d5af8b0e2b63$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $6e21d5af8b0e2b63$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value;
    }
}
function $6e21d5af8b0e2b63$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $6e21d5af8b0e2b63$var$setClasses(el, value);
}
function $6e21d5af8b0e2b63$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $6e21d5af8b0e2b63$var$setStyles(el, value);
}
function $6e21d5af8b0e2b63$var$bindAttributeAndProperty(el, name, value) {
    $6e21d5af8b0e2b63$var$bindAttribute(el, name, value);
    $6e21d5af8b0e2b63$var$setPropertyIfChanged(el, name, value);
}
function $6e21d5af8b0e2b63$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $6e21d5af8b0e2b63$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($6e21d5af8b0e2b63$var$isBooleanAttr(name)) value = name;
        $6e21d5af8b0e2b63$var$setIfChanged(el, name, value);
    }
}
function $6e21d5af8b0e2b63$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $6e21d5af8b0e2b63$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $6e21d5af8b0e2b63$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $6e21d5af8b0e2b63$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $6e21d5af8b0e2b63$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $6e21d5af8b0e2b63$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $6e21d5af8b0e2b63$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $6e21d5af8b0e2b63$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($6e21d5af8b0e2b63$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $6e21d5af8b0e2b63$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $6e21d5af8b0e2b63$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/plugin.js
function $6e21d5af8b0e2b63$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($6e21d5af8b0e2b63$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $6e21d5af8b0e2b63$var$stores = {};
var $6e21d5af8b0e2b63$var$isReactive = false;
function $6e21d5af8b0e2b63$var$store(name, value) {
    if (!$6e21d5af8b0e2b63$var$isReactive) {
        $6e21d5af8b0e2b63$var$stores = $6e21d5af8b0e2b63$var$reactive($6e21d5af8b0e2b63$var$stores);
        $6e21d5af8b0e2b63$var$isReactive = true;
    }
    if (value === void 0) return $6e21d5af8b0e2b63$var$stores[name];
    $6e21d5af8b0e2b63$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $6e21d5af8b0e2b63$var$stores[name].init();
    $6e21d5af8b0e2b63$var$initInterceptors($6e21d5af8b0e2b63$var$stores[name]);
}
function $6e21d5af8b0e2b63$var$getStores() {
    return $6e21d5af8b0e2b63$var$stores;
}
// packages/alpinejs/src/binds.js
var $6e21d5af8b0e2b63$var$binds = {};
function $6e21d5af8b0e2b63$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) $6e21d5af8b0e2b63$var$applyBindingsObject(name, getBindings());
    else $6e21d5af8b0e2b63$var$binds[name] = getBindings;
}
function $6e21d5af8b0e2b63$var$injectBindingProviders(obj) {
    Object.entries($6e21d5af8b0e2b63$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $6e21d5af8b0e2b63$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $6e21d5af8b0e2b63$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $6e21d5af8b0e2b63$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
}
// packages/alpinejs/src/datas.js
var $6e21d5af8b0e2b63$var$datas = {};
function $6e21d5af8b0e2b63$var$data(name, callback) {
    $6e21d5af8b0e2b63$var$datas[name] = callback;
}
function $6e21d5af8b0e2b63$var$injectDataProviders(obj, context) {
    Object.entries($6e21d5af8b0e2b63$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $6e21d5af8b0e2b63$var$Alpine = {
    get reactive () {
        return $6e21d5af8b0e2b63$var$reactive;
    },
    get release () {
        return $6e21d5af8b0e2b63$var$release;
    },
    get effect () {
        return $6e21d5af8b0e2b63$var$effect;
    },
    get raw () {
        return $6e21d5af8b0e2b63$var$raw;
    },
    version: "3.12.2",
    flushAndStopDeferringMutations: $6e21d5af8b0e2b63$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $6e21d5af8b0e2b63$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $6e21d5af8b0e2b63$var$disableEffectScheduling,
    startObservingMutations: $6e21d5af8b0e2b63$var$startObservingMutations,
    stopObservingMutations: $6e21d5af8b0e2b63$var$stopObservingMutations,
    setReactivityEngine: $6e21d5af8b0e2b63$var$setReactivityEngine,
    closestDataStack: $6e21d5af8b0e2b63$var$closestDataStack,
    skipDuringClone: $6e21d5af8b0e2b63$var$skipDuringClone,
    onlyDuringClone: $6e21d5af8b0e2b63$var$onlyDuringClone,
    addRootSelector: $6e21d5af8b0e2b63$var$addRootSelector,
    addInitSelector: $6e21d5af8b0e2b63$var$addInitSelector,
    addScopeToNode: $6e21d5af8b0e2b63$var$addScopeToNode,
    deferMutations: $6e21d5af8b0e2b63$var$deferMutations,
    mapAttributes: $6e21d5af8b0e2b63$var$mapAttributes,
    evaluateLater: $6e21d5af8b0e2b63$var$evaluateLater,
    interceptInit: $6e21d5af8b0e2b63$var$interceptInit,
    setEvaluator: $6e21d5af8b0e2b63$var$setEvaluator,
    mergeProxies: $6e21d5af8b0e2b63$var$mergeProxies,
    findClosest: $6e21d5af8b0e2b63$var$findClosest,
    closestRoot: $6e21d5af8b0e2b63$var$closestRoot,
    destroyTree: $6e21d5af8b0e2b63$var$destroyTree,
    interceptor: $6e21d5af8b0e2b63$var$interceptor,
    transition: $6e21d5af8b0e2b63$var$transition,
    setStyles: $6e21d5af8b0e2b63$var$setStyles,
    mutateDom: $6e21d5af8b0e2b63$var$mutateDom,
    directive: $6e21d5af8b0e2b63$var$directive,
    throttle: $6e21d5af8b0e2b63$var$throttle,
    debounce: $6e21d5af8b0e2b63$var$debounce,
    evaluate: $6e21d5af8b0e2b63$var$evaluate,
    initTree: $6e21d5af8b0e2b63$var$initTree,
    nextTick: $6e21d5af8b0e2b63$var$nextTick,
    prefixed: $6e21d5af8b0e2b63$var$prefix,
    prefix: $6e21d5af8b0e2b63$var$setPrefix,
    plugin: $6e21d5af8b0e2b63$var$plugin,
    magic: $6e21d5af8b0e2b63$var$magic,
    store: $6e21d5af8b0e2b63$var$store,
    start: $6e21d5af8b0e2b63$var$start,
    clone: $6e21d5af8b0e2b63$var$clone,
    bound: $6e21d5af8b0e2b63$var$getBinding,
    $data: $6e21d5af8b0e2b63$var$scope,
    walk: $6e21d5af8b0e2b63$var$walk,
    data: $6e21d5af8b0e2b63$var$data,
    bind: $6e21d5af8b0e2b63$var$bind2
};
var $6e21d5af8b0e2b63$var$alpine_default = $6e21d5af8b0e2b63$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $6e21d5af8b0e2b63$var$makeMap(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $6e21d5af8b0e2b63$var$PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
var $6e21d5af8b0e2b63$var$slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
var $6e21d5af8b0e2b63$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $6e21d5af8b0e2b63$var$isBooleanAttr2 = /* @__PURE__ */ $6e21d5af8b0e2b63$var$makeMap($6e21d5af8b0e2b63$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $6e21d5af8b0e2b63$var$EMPTY_OBJ = Object.freeze({});
var $6e21d5af8b0e2b63$var$EMPTY_ARR = Object.freeze([]);
var $6e21d5af8b0e2b63$var$extend = Object.assign;
var $6e21d5af8b0e2b63$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $6e21d5af8b0e2b63$var$hasOwn = (val, key)=>$6e21d5af8b0e2b63$var$hasOwnProperty.call(val, key);
var $6e21d5af8b0e2b63$var$isArray = Array.isArray;
var $6e21d5af8b0e2b63$var$isMap = (val)=>$6e21d5af8b0e2b63$var$toTypeString(val) === "[object Map]";
var $6e21d5af8b0e2b63$var$isString = (val)=>typeof val === "string";
var $6e21d5af8b0e2b63$var$isSymbol = (val)=>typeof val === "symbol";
var $6e21d5af8b0e2b63$var$isObject = (val)=>val !== null && typeof val === "object";
var $6e21d5af8b0e2b63$var$objectToString = Object.prototype.toString;
var $6e21d5af8b0e2b63$var$toTypeString = (value)=>$6e21d5af8b0e2b63$var$objectToString.call(value);
var $6e21d5af8b0e2b63$var$toRawType = (value)=>{
    return $6e21d5af8b0e2b63$var$toTypeString(value).slice(8, -1);
};
var $6e21d5af8b0e2b63$var$isIntegerKey = (key)=>$6e21d5af8b0e2b63$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $6e21d5af8b0e2b63$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $6e21d5af8b0e2b63$var$camelizeRE = /-(\w)/g;
var $6e21d5af8b0e2b63$var$camelize = $6e21d5af8b0e2b63$var$cacheStringFunction((str)=>{
    return str.replace($6e21d5af8b0e2b63$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $6e21d5af8b0e2b63$var$hyphenateRE = /\B([A-Z])/g;
var $6e21d5af8b0e2b63$var$hyphenate = $6e21d5af8b0e2b63$var$cacheStringFunction((str)=>str.replace($6e21d5af8b0e2b63$var$hyphenateRE, "-$1").toLowerCase());
var $6e21d5af8b0e2b63$var$capitalize = $6e21d5af8b0e2b63$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $6e21d5af8b0e2b63$var$toHandlerKey = $6e21d5af8b0e2b63$var$cacheStringFunction((str)=>str ? `on${$6e21d5af8b0e2b63$var$capitalize(str)}` : ``);
var $6e21d5af8b0e2b63$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $6e21d5af8b0e2b63$var$targetMap = new WeakMap();
var $6e21d5af8b0e2b63$var$effectStack = [];
var $6e21d5af8b0e2b63$var$activeEffect;
var $6e21d5af8b0e2b63$var$ITERATE_KEY = Symbol("iterate");
var $6e21d5af8b0e2b63$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $6e21d5af8b0e2b63$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $6e21d5af8b0e2b63$var$effect2(fn, options = $6e21d5af8b0e2b63$var$EMPTY_OBJ) {
    if ($6e21d5af8b0e2b63$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $6e21d5af8b0e2b63$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $6e21d5af8b0e2b63$var$stop(effect3) {
    if (effect3.active) {
        $6e21d5af8b0e2b63$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $6e21d5af8b0e2b63$var$uid = 0;
function $6e21d5af8b0e2b63$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$6e21d5af8b0e2b63$var$effectStack.includes(effect3)) {
            $6e21d5af8b0e2b63$var$cleanup(effect3);
            try {
                $6e21d5af8b0e2b63$var$enableTracking();
                $6e21d5af8b0e2b63$var$effectStack.push(effect3);
                $6e21d5af8b0e2b63$var$activeEffect = effect3;
                return fn();
            } finally{
                $6e21d5af8b0e2b63$var$effectStack.pop();
                $6e21d5af8b0e2b63$var$resetTracking();
                $6e21d5af8b0e2b63$var$activeEffect = $6e21d5af8b0e2b63$var$effectStack[$6e21d5af8b0e2b63$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $6e21d5af8b0e2b63$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $6e21d5af8b0e2b63$var$cleanup(effect3) {
    const { deps: deps  } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $6e21d5af8b0e2b63$var$shouldTrack = true;
var $6e21d5af8b0e2b63$var$trackStack = [];
function $6e21d5af8b0e2b63$var$pauseTracking() {
    $6e21d5af8b0e2b63$var$trackStack.push($6e21d5af8b0e2b63$var$shouldTrack);
    $6e21d5af8b0e2b63$var$shouldTrack = false;
}
function $6e21d5af8b0e2b63$var$enableTracking() {
    $6e21d5af8b0e2b63$var$trackStack.push($6e21d5af8b0e2b63$var$shouldTrack);
    $6e21d5af8b0e2b63$var$shouldTrack = true;
}
function $6e21d5af8b0e2b63$var$resetTracking() {
    const last = $6e21d5af8b0e2b63$var$trackStack.pop();
    $6e21d5af8b0e2b63$var$shouldTrack = last === void 0 ? true : last;
}
function $6e21d5af8b0e2b63$var$track(target, type, key) {
    if (!$6e21d5af8b0e2b63$var$shouldTrack || $6e21d5af8b0e2b63$var$activeEffect === void 0) return;
    let depsMap = $6e21d5af8b0e2b63$var$targetMap.get(target);
    if (!depsMap) $6e21d5af8b0e2b63$var$targetMap.set(target, depsMap = new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = new Set());
    if (!dep.has($6e21d5af8b0e2b63$var$activeEffect)) {
        dep.add($6e21d5af8b0e2b63$var$activeEffect);
        $6e21d5af8b0e2b63$var$activeEffect.deps.push(dep);
        if ($6e21d5af8b0e2b63$var$activeEffect.options.onTrack) $6e21d5af8b0e2b63$var$activeEffect.options.onTrack({
            effect: $6e21d5af8b0e2b63$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $6e21d5af8b0e2b63$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $6e21d5af8b0e2b63$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $6e21d5af8b0e2b63$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $6e21d5af8b0e2b63$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$6e21d5af8b0e2b63$var$isArray(target)) {
                    add2(depsMap.get($6e21d5af8b0e2b63$var$ITERATE_KEY));
                    if ($6e21d5af8b0e2b63$var$isMap(target)) add2(depsMap.get($6e21d5af8b0e2b63$var$MAP_KEY_ITERATE_KEY));
                } else if ($6e21d5af8b0e2b63$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$6e21d5af8b0e2b63$var$isArray(target)) {
                    add2(depsMap.get($6e21d5af8b0e2b63$var$ITERATE_KEY));
                    if ($6e21d5af8b0e2b63$var$isMap(target)) add2(depsMap.get($6e21d5af8b0e2b63$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($6e21d5af8b0e2b63$var$isMap(target)) add2(depsMap.get($6e21d5af8b0e2b63$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $6e21d5af8b0e2b63$var$isNonTrackableKeys = /* @__PURE__ */ $6e21d5af8b0e2b63$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $6e21d5af8b0e2b63$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($6e21d5af8b0e2b63$var$isSymbol));
var $6e21d5af8b0e2b63$var$get2 = /* @__PURE__ */ $6e21d5af8b0e2b63$var$createGetter();
var $6e21d5af8b0e2b63$var$shallowGet = /* @__PURE__ */ $6e21d5af8b0e2b63$var$createGetter(false, true);
var $6e21d5af8b0e2b63$var$readonlyGet = /* @__PURE__ */ $6e21d5af8b0e2b63$var$createGetter(true);
var $6e21d5af8b0e2b63$var$shallowReadonlyGet = /* @__PURE__ */ $6e21d5af8b0e2b63$var$createGetter(true, true);
var $6e21d5af8b0e2b63$var$arrayInstrumentations = {};
[
    "includes",
    "indexOf",
    "lastIndexOf"
].forEach((key)=>{
    const method = Array.prototype[key];
    $6e21d5af8b0e2b63$var$arrayInstrumentations[key] = function(...args) {
        const arr = $6e21d5af8b0e2b63$var$toRaw(this);
        for(let i = 0, l = this.length; i < l; i++)$6e21d5af8b0e2b63$var$track(arr, "get", i + "");
        const res = method.apply(arr, args);
        if (res === -1 || res === false) return method.apply(arr, args.map($6e21d5af8b0e2b63$var$toRaw));
        else return res;
    };
});
[
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
].forEach((key)=>{
    const method = Array.prototype[key];
    $6e21d5af8b0e2b63$var$arrayInstrumentations[key] = function(...args) {
        $6e21d5af8b0e2b63$var$pauseTracking();
        const res = method.apply(this, args);
        $6e21d5af8b0e2b63$var$resetTracking();
        return res;
    };
});
function $6e21d5af8b0e2b63$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $6e21d5af8b0e2b63$var$shallowReadonlyMap : $6e21d5af8b0e2b63$var$readonlyMap : shallow ? $6e21d5af8b0e2b63$var$shallowReactiveMap : $6e21d5af8b0e2b63$var$reactiveMap).get(target)) return target;
        const targetIsArray = $6e21d5af8b0e2b63$var$isArray(target);
        if (!isReadonly && targetIsArray && $6e21d5af8b0e2b63$var$hasOwn($6e21d5af8b0e2b63$var$arrayInstrumentations, key)) return Reflect.get($6e21d5af8b0e2b63$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($6e21d5af8b0e2b63$var$isSymbol(key) ? $6e21d5af8b0e2b63$var$builtInSymbols.has(key) : $6e21d5af8b0e2b63$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $6e21d5af8b0e2b63$var$track(target, "get", key);
        if (shallow) return res;
        if ($6e21d5af8b0e2b63$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$6e21d5af8b0e2b63$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($6e21d5af8b0e2b63$var$isObject(res)) return isReadonly ? $6e21d5af8b0e2b63$var$readonly(res) : $6e21d5af8b0e2b63$var$reactive2(res);
        return res;
    };
}
var $6e21d5af8b0e2b63$var$set2 = /* @__PURE__ */ $6e21d5af8b0e2b63$var$createSetter();
var $6e21d5af8b0e2b63$var$shallowSet = /* @__PURE__ */ $6e21d5af8b0e2b63$var$createSetter(true);
function $6e21d5af8b0e2b63$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $6e21d5af8b0e2b63$var$toRaw(value);
            oldValue = $6e21d5af8b0e2b63$var$toRaw(oldValue);
            if (!$6e21d5af8b0e2b63$var$isArray(target) && $6e21d5af8b0e2b63$var$isRef(oldValue) && !$6e21d5af8b0e2b63$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $6e21d5af8b0e2b63$var$isArray(target) && $6e21d5af8b0e2b63$var$isIntegerKey(key) ? Number(key) < target.length : $6e21d5af8b0e2b63$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $6e21d5af8b0e2b63$var$toRaw(receiver)) {
            if (!hadKey) $6e21d5af8b0e2b63$var$trigger(target, "add", key, value);
            else if ($6e21d5af8b0e2b63$var$hasChanged(value, oldValue)) $6e21d5af8b0e2b63$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $6e21d5af8b0e2b63$var$deleteProperty(target, key) {
    const hadKey = $6e21d5af8b0e2b63$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $6e21d5af8b0e2b63$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $6e21d5af8b0e2b63$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$6e21d5af8b0e2b63$var$isSymbol(key) || !$6e21d5af8b0e2b63$var$builtInSymbols.has(key)) $6e21d5af8b0e2b63$var$track(target, "has", key);
    return result;
}
function $6e21d5af8b0e2b63$var$ownKeys(target) {
    $6e21d5af8b0e2b63$var$track(target, "iterate", $6e21d5af8b0e2b63$var$isArray(target) ? "length" : $6e21d5af8b0e2b63$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $6e21d5af8b0e2b63$var$mutableHandlers = {
    get: $6e21d5af8b0e2b63$var$get2,
    set: $6e21d5af8b0e2b63$var$set2,
    deleteProperty: $6e21d5af8b0e2b63$var$deleteProperty,
    has: $6e21d5af8b0e2b63$var$has,
    ownKeys: $6e21d5af8b0e2b63$var$ownKeys
};
var $6e21d5af8b0e2b63$var$readonlyHandlers = {
    get: $6e21d5af8b0e2b63$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $6e21d5af8b0e2b63$var$shallowReactiveHandlers = $6e21d5af8b0e2b63$var$extend({}, $6e21d5af8b0e2b63$var$mutableHandlers, {
    get: $6e21d5af8b0e2b63$var$shallowGet,
    set: $6e21d5af8b0e2b63$var$shallowSet
});
var $6e21d5af8b0e2b63$var$shallowReadonlyHandlers = $6e21d5af8b0e2b63$var$extend({}, $6e21d5af8b0e2b63$var$readonlyHandlers, {
    get: $6e21d5af8b0e2b63$var$shallowReadonlyGet
});
var $6e21d5af8b0e2b63$var$toReactive = (value)=>$6e21d5af8b0e2b63$var$isObject(value) ? $6e21d5af8b0e2b63$var$reactive2(value) : value;
var $6e21d5af8b0e2b63$var$toReadonly = (value)=>$6e21d5af8b0e2b63$var$isObject(value) ? $6e21d5af8b0e2b63$var$readonly(value) : value;
var $6e21d5af8b0e2b63$var$toShallow = (value)=>value;
var $6e21d5af8b0e2b63$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $6e21d5af8b0e2b63$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $6e21d5af8b0e2b63$var$toRaw(target);
    const rawKey = $6e21d5af8b0e2b63$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $6e21d5af8b0e2b63$var$track(rawTarget, "get", key);
    !isReadonly && $6e21d5af8b0e2b63$var$track(rawTarget, "get", rawKey);
    const { has: has2  } = $6e21d5af8b0e2b63$var$getProto(rawTarget);
    const wrap = isShallow ? $6e21d5af8b0e2b63$var$toShallow : isReadonly ? $6e21d5af8b0e2b63$var$toReadonly : $6e21d5af8b0e2b63$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $6e21d5af8b0e2b63$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $6e21d5af8b0e2b63$var$toRaw(target);
    const rawKey = $6e21d5af8b0e2b63$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $6e21d5af8b0e2b63$var$track(rawTarget, "has", key);
    !isReadonly && $6e21d5af8b0e2b63$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $6e21d5af8b0e2b63$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $6e21d5af8b0e2b63$var$track($6e21d5af8b0e2b63$var$toRaw(target), "iterate", $6e21d5af8b0e2b63$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $6e21d5af8b0e2b63$var$add(value) {
    value = $6e21d5af8b0e2b63$var$toRaw(value);
    const target = $6e21d5af8b0e2b63$var$toRaw(this);
    const proto = $6e21d5af8b0e2b63$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $6e21d5af8b0e2b63$var$trigger(target, "add", value, value);
    }
    return this;
}
function $6e21d5af8b0e2b63$var$set$1(key, value) {
    value = $6e21d5af8b0e2b63$var$toRaw(value);
    const target = $6e21d5af8b0e2b63$var$toRaw(this);
    const { has: has2 , get: get3  } = $6e21d5af8b0e2b63$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $6e21d5af8b0e2b63$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $6e21d5af8b0e2b63$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $6e21d5af8b0e2b63$var$trigger(target, "add", key, value);
    else if ($6e21d5af8b0e2b63$var$hasChanged(value, oldValue)) $6e21d5af8b0e2b63$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $6e21d5af8b0e2b63$var$deleteEntry(key) {
    const target = $6e21d5af8b0e2b63$var$toRaw(this);
    const { has: has2 , get: get3  } = $6e21d5af8b0e2b63$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $6e21d5af8b0e2b63$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $6e21d5af8b0e2b63$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $6e21d5af8b0e2b63$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $6e21d5af8b0e2b63$var$clear() {
    const target = $6e21d5af8b0e2b63$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $6e21d5af8b0e2b63$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $6e21d5af8b0e2b63$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $6e21d5af8b0e2b63$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $6e21d5af8b0e2b63$var$toRaw(target);
        const wrap = isShallow ? $6e21d5af8b0e2b63$var$toShallow : isReadonly ? $6e21d5af8b0e2b63$var$toReadonly : $6e21d5af8b0e2b63$var$toReactive;
        !isReadonly && $6e21d5af8b0e2b63$var$track(rawTarget, "iterate", $6e21d5af8b0e2b63$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $6e21d5af8b0e2b63$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $6e21d5af8b0e2b63$var$toRaw(target);
        const targetIsMap = $6e21d5af8b0e2b63$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $6e21d5af8b0e2b63$var$toShallow : isReadonly ? $6e21d5af8b0e2b63$var$toReadonly : $6e21d5af8b0e2b63$var$toReactive;
        !isReadonly && $6e21d5af8b0e2b63$var$track(rawTarget, "iterate", isKeyOnly ? $6e21d5af8b0e2b63$var$MAP_KEY_ITERATE_KEY : $6e21d5af8b0e2b63$var$ITERATE_KEY);
        return {
            next () {
                const { value: value , done: done  } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $6e21d5af8b0e2b63$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$6e21d5af8b0e2b63$var$capitalize(type)} operation ${key}failed: target is readonly.`, $6e21d5af8b0e2b63$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
var $6e21d5af8b0e2b63$var$mutableInstrumentations = {
    get (key) {
        return $6e21d5af8b0e2b63$var$get$1(this, key);
    },
    get size () {
        return $6e21d5af8b0e2b63$var$size(this);
    },
    has: $6e21d5af8b0e2b63$var$has$1,
    add: $6e21d5af8b0e2b63$var$add,
    set: $6e21d5af8b0e2b63$var$set$1,
    delete: $6e21d5af8b0e2b63$var$deleteEntry,
    clear: $6e21d5af8b0e2b63$var$clear,
    forEach: $6e21d5af8b0e2b63$var$createForEach(false, false)
};
var $6e21d5af8b0e2b63$var$shallowInstrumentations = {
    get (key) {
        return $6e21d5af8b0e2b63$var$get$1(this, key, false, true);
    },
    get size () {
        return $6e21d5af8b0e2b63$var$size(this);
    },
    has: $6e21d5af8b0e2b63$var$has$1,
    add: $6e21d5af8b0e2b63$var$add,
    set: $6e21d5af8b0e2b63$var$set$1,
    delete: $6e21d5af8b0e2b63$var$deleteEntry,
    clear: $6e21d5af8b0e2b63$var$clear,
    forEach: $6e21d5af8b0e2b63$var$createForEach(false, true)
};
var $6e21d5af8b0e2b63$var$readonlyInstrumentations = {
    get (key) {
        return $6e21d5af8b0e2b63$var$get$1(this, key, true);
    },
    get size () {
        return $6e21d5af8b0e2b63$var$size(this, true);
    },
    has (key) {
        return $6e21d5af8b0e2b63$var$has$1.call(this, key, true);
    },
    add: $6e21d5af8b0e2b63$var$createReadonlyMethod("add"),
    set: $6e21d5af8b0e2b63$var$createReadonlyMethod("set"),
    delete: $6e21d5af8b0e2b63$var$createReadonlyMethod("delete"),
    clear: $6e21d5af8b0e2b63$var$createReadonlyMethod("clear"),
    forEach: $6e21d5af8b0e2b63$var$createForEach(true, false)
};
var $6e21d5af8b0e2b63$var$shallowReadonlyInstrumentations = {
    get (key) {
        return $6e21d5af8b0e2b63$var$get$1(this, key, true, true);
    },
    get size () {
        return $6e21d5af8b0e2b63$var$size(this, true);
    },
    has (key) {
        return $6e21d5af8b0e2b63$var$has$1.call(this, key, true);
    },
    add: $6e21d5af8b0e2b63$var$createReadonlyMethod("add"),
    set: $6e21d5af8b0e2b63$var$createReadonlyMethod("set"),
    delete: $6e21d5af8b0e2b63$var$createReadonlyMethod("delete"),
    clear: $6e21d5af8b0e2b63$var$createReadonlyMethod("clear"),
    forEach: $6e21d5af8b0e2b63$var$createForEach(true, true)
};
var $6e21d5af8b0e2b63$var$iteratorMethods = [
    "keys",
    "values",
    "entries",
    Symbol.iterator
];
$6e21d5af8b0e2b63$var$iteratorMethods.forEach((method)=>{
    $6e21d5af8b0e2b63$var$mutableInstrumentations[method] = $6e21d5af8b0e2b63$var$createIterableMethod(method, false, false);
    $6e21d5af8b0e2b63$var$readonlyInstrumentations[method] = $6e21d5af8b0e2b63$var$createIterableMethod(method, true, false);
    $6e21d5af8b0e2b63$var$shallowInstrumentations[method] = $6e21d5af8b0e2b63$var$createIterableMethod(method, false, true);
    $6e21d5af8b0e2b63$var$shallowReadonlyInstrumentations[method] = $6e21d5af8b0e2b63$var$createIterableMethod(method, true, true);
});
function $6e21d5af8b0e2b63$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $6e21d5af8b0e2b63$var$shallowReadonlyInstrumentations : $6e21d5af8b0e2b63$var$shallowInstrumentations : isReadonly ? $6e21d5af8b0e2b63$var$readonlyInstrumentations : $6e21d5af8b0e2b63$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($6e21d5af8b0e2b63$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $6e21d5af8b0e2b63$var$mutableCollectionHandlers = {
    get: $6e21d5af8b0e2b63$var$createInstrumentationGetter(false, false)
};
var $6e21d5af8b0e2b63$var$shallowCollectionHandlers = {
    get: $6e21d5af8b0e2b63$var$createInstrumentationGetter(false, true)
};
var $6e21d5af8b0e2b63$var$readonlyCollectionHandlers = {
    get: $6e21d5af8b0e2b63$var$createInstrumentationGetter(true, false)
};
var $6e21d5af8b0e2b63$var$shallowReadonlyCollectionHandlers = {
    get: $6e21d5af8b0e2b63$var$createInstrumentationGetter(true, true)
};
function $6e21d5af8b0e2b63$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $6e21d5af8b0e2b63$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $6e21d5af8b0e2b63$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $6e21d5af8b0e2b63$var$reactiveMap = new WeakMap();
var $6e21d5af8b0e2b63$var$shallowReactiveMap = new WeakMap();
var $6e21d5af8b0e2b63$var$readonlyMap = new WeakMap();
var $6e21d5af8b0e2b63$var$shallowReadonlyMap = new WeakMap();
function $6e21d5af8b0e2b63$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $6e21d5af8b0e2b63$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $6e21d5af8b0e2b63$var$targetTypeMap($6e21d5af8b0e2b63$var$toRawType(value));
}
function $6e21d5af8b0e2b63$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $6e21d5af8b0e2b63$var$createReactiveObject(target, false, $6e21d5af8b0e2b63$var$mutableHandlers, $6e21d5af8b0e2b63$var$mutableCollectionHandlers, $6e21d5af8b0e2b63$var$reactiveMap);
}
function $6e21d5af8b0e2b63$var$readonly(target) {
    return $6e21d5af8b0e2b63$var$createReactiveObject(target, true, $6e21d5af8b0e2b63$var$readonlyHandlers, $6e21d5af8b0e2b63$var$readonlyCollectionHandlers, $6e21d5af8b0e2b63$var$readonlyMap);
}
function $6e21d5af8b0e2b63$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$6e21d5af8b0e2b63$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $6e21d5af8b0e2b63$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $6e21d5af8b0e2b63$var$toRaw(observed) {
    return observed && $6e21d5af8b0e2b63$var$toRaw(observed["__v_raw"]) || observed;
}
function $6e21d5af8b0e2b63$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$6e21d5af8b0e2b63$var$magic("nextTick", ()=>$6e21d5af8b0e2b63$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$6e21d5af8b0e2b63$var$magic("dispatch", (el)=>$6e21d5af8b0e2b63$var$dispatch.bind($6e21d5af8b0e2b63$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$6e21d5af8b0e2b63$var$magic("watch", (el, { evaluateLater: evaluateLater2 , effect: effect3  })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let firstTime = true;
        let oldValue;
        let effectReference = effect3(()=>evaluate2((value)=>{
                JSON.stringify(value);
                if (!firstTime) queueMicrotask(()=>{
                    callback(value, oldValue);
                    oldValue = value;
                });
                else oldValue = value;
                firstTime = false;
            }));
        el._x_effects.delete(effectReference);
    });
// packages/alpinejs/src/magics/$store.js
$6e21d5af8b0e2b63$var$magic("store", $6e21d5af8b0e2b63$var$getStores);
// packages/alpinejs/src/magics/$data.js
$6e21d5af8b0e2b63$var$magic("data", (el)=>$6e21d5af8b0e2b63$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$6e21d5af8b0e2b63$var$magic("root", (el)=>$6e21d5af8b0e2b63$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$6e21d5af8b0e2b63$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $6e21d5af8b0e2b63$var$mergeProxies($6e21d5af8b0e2b63$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $6e21d5af8b0e2b63$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $6e21d5af8b0e2b63$var$globalIdMemo = {};
function $6e21d5af8b0e2b63$var$findAndIncrementId(name) {
    if (!$6e21d5af8b0e2b63$var$globalIdMemo[name]) $6e21d5af8b0e2b63$var$globalIdMemo[name] = 0;
    return ++$6e21d5af8b0e2b63$var$globalIdMemo[name];
}
function $6e21d5af8b0e2b63$var$closestIdRoot(el, name) {
    return $6e21d5af8b0e2b63$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $6e21d5af8b0e2b63$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $6e21d5af8b0e2b63$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$6e21d5af8b0e2b63$var$magic("id", (el)=>(name, key = null)=>{
        let root = $6e21d5af8b0e2b63$var$closestIdRoot(el, name);
        let id = root ? root._x_ids[name] : $6e21d5af8b0e2b63$var$findAndIncrementId(name);
        return key ? `${name}-${id}-${key}` : `${name}-${id}`;
    });
// packages/alpinejs/src/magics/$el.js
$6e21d5af8b0e2b63$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$6e21d5af8b0e2b63$var$warnMissingPluginMagic("Focus", "focus", "focus");
$6e21d5af8b0e2b63$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $6e21d5af8b0e2b63$var$warnMissingPluginMagic(name, magicName, slug) {
    $6e21d5af8b0e2b63$var$magic(magicName, (el)=>$6e21d5af8b0e2b63$var$warn(`You can't use [$${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/entangle.js
function $6e21d5af8b0e2b63$var$entangle({ get: outerGet , set: outerSet  }, { get: innerGet , set: innerSet  }) {
    let firstRun = true;
    let outerHash, innerHash, outerHashLatest, innerHashLatest;
    let reference = $6e21d5af8b0e2b63$var$effect(()=>{
        let outer, inner;
        if (firstRun) {
            outer = outerGet();
            innerSet(outer);
            inner = innerGet();
            firstRun = false;
        } else {
            outer = outerGet();
            inner = innerGet();
            outerHashLatest = JSON.stringify(outer);
            innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) {
                inner = innerGet();
                innerSet(outer);
                inner = outer;
            } else {
                outerSet(inner);
                outer = inner;
            }
        }
        outerHash = JSON.stringify(outer);
        innerHash = JSON.stringify(inner);
    });
    return ()=>{
        $6e21d5af8b0e2b63$var$release(reference);
    };
}
// packages/alpinejs/src/directives/x-modelable.js
$6e21d5af8b0e2b63$var$directive("modelable", (el, { expression: expression  }, { effect: effect3 , evaluateLater: evaluateLater2 , cleanup: cleanup2  })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                __placeholder: val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $6e21d5af8b0e2b63$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
var $6e21d5af8b0e2b63$var$teleportContainerDuringClone = document.createElement("div");
$6e21d5af8b0e2b63$var$directive("teleport", (el, { modifiers: modifiers , expression: expression  }, { cleanup: cleanup2  })=>{
    if (el.tagName.toLowerCase() !== "template") $6e21d5af8b0e2b63$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $6e21d5af8b0e2b63$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $6e21d5af8b0e2b63$var$teleportContainerDuringClone;
    })();
    if (!target) $6e21d5af8b0e2b63$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $6e21d5af8b0e2b63$var$addScopeToNode(clone2, {}, el);
    $6e21d5af8b0e2b63$var$mutateDom(()=>{
        if (modifiers.includes("prepend")) target.parentNode.insertBefore(clone2, target);
        else if (modifiers.includes("append")) target.parentNode.insertBefore(clone2, target.nextSibling);
        else target.appendChild(clone2);
        $6e21d5af8b0e2b63$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    cleanup2(()=>clone2.remove());
});
// packages/alpinejs/src/directives/x-ignore.js
var $6e21d5af8b0e2b63$var$handler = ()=>{};
$6e21d5af8b0e2b63$var$handler.inline = (el, { modifiers: modifiers  }, { cleanup: cleanup2  })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$6e21d5af8b0e2b63$var$directive("ignore", $6e21d5af8b0e2b63$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$6e21d5af8b0e2b63$var$directive("effect", (el, { expression: expression  }, { effect: effect3  })=>effect3($6e21d5af8b0e2b63$var$evaluateLater(el, expression)));
// packages/alpinejs/src/utils/on.js
function $6e21d5af8b0e2b63$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler3 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $6e21d5af8b0e2b63$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $6e21d5af8b0e2b63$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $6e21d5af8b0e2b63$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler3 = $6e21d5af8b0e2b63$var$debounce(handler3, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $6e21d5af8b0e2b63$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler3 = $6e21d5af8b0e2b63$var$throttle(handler3, wait);
    }
    if (modifiers.includes("prevent")) handler3 = wrapHandler(handler3, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler3 = wrapHandler(handler3, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler3 = wrapHandler(handler3, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler3 = wrapHandler(handler3, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler3 = wrapHandler(handler3, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler3, options);
    });
    handler3 = wrapHandler(handler3, (next, e)=>{
        if ($6e21d5af8b0e2b63$var$isKeyEvent(event)) {
            if ($6e21d5af8b0e2b63$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler3, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler3, options);
    };
}
function $6e21d5af8b0e2b63$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $6e21d5af8b0e2b63$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $6e21d5af8b0e2b63$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $6e21d5af8b0e2b63$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $6e21d5af8b0e2b63$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $6e21d5af8b0e2b63$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $6e21d5af8b0e2b63$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $6e21d5af8b0e2b63$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $6e21d5af8b0e2b63$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($6e21d5af8b0e2b63$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $6e21d5af8b0e2b63$var$keyToModifiers(key) {
    if (!key) return [];
    key = $6e21d5af8b0e2b63$var$kebabCase2(key);
    let modifierToKeyMap = {
        ctrl: "control",
        slash: "/",
        space: " ",
        spacebar: " ",
        cmd: "meta",
        esc: "escape",
        up: "arrow-up",
        down: "arrow-down",
        left: "arrow-left",
        right: "arrow-right",
        period: ".",
        equal: "=",
        minus: "-",
        underscore: "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$6e21d5af8b0e2b63$var$directive("model", (el, { modifiers: modifiers , expression: expression  }, { effect: effect3 , cleanup: cleanup2  })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $6e21d5af8b0e2b63$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $6e21d5af8b0e2b63$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $6e21d5af8b0e2b63$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $6e21d5af8b0e2b63$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($6e21d5af8b0e2b63$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                __placeholder: value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $6e21d5af8b0e2b63$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $6e21d5af8b0e2b63$var$isCloning ? ()=>{} : $6e21d5af8b0e2b63$var$on(el, event, modifiers, (e)=>{
        setValue($6e21d5af8b0e2b63$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill") && [
        null,
        ""
    ].includes(getValue())) el.dispatchEvent(new Event(event, {}));
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $6e21d5af8b0e2b63$var$on(el.form, "reset", [], (e)=>{
            $6e21d5af8b0e2b63$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        value = value === void 0 ? getValue() : value;
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $6e21d5af8b0e2b63$var$mutateDom(()=>$6e21d5af8b0e2b63$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $6e21d5af8b0e2b63$var$getInputValue(el, modifiers, event, currentValue) {
    return $6e21d5af8b0e2b63$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail ?? event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = modifiers.includes("number") ? $6e21d5af8b0e2b63$var$safeParseNumber(event.target.value) : event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$6e21d5af8b0e2b63$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) return modifiers.includes("number") ? Array.from(event.target.selectedOptions).map((option)=>{
            let rawValue = option.value || option.text;
            return $6e21d5af8b0e2b63$var$safeParseNumber(rawValue);
        }) : Array.from(event.target.selectedOptions).map((option)=>{
            return option.value || option.text;
        });
        else {
            let rawValue = event.target.value;
            return modifiers.includes("number") ? $6e21d5af8b0e2b63$var$safeParseNumber(rawValue) : modifiers.includes("trim") ? rawValue.trim() : rawValue;
        }
    });
}
function $6e21d5af8b0e2b63$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $6e21d5af8b0e2b63$var$isNumeric2(number) ? number : rawValue;
}
function $6e21d5af8b0e2b63$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $6e21d5af8b0e2b63$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $6e21d5af8b0e2b63$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$6e21d5af8b0e2b63$var$directive("cloak", (el)=>queueMicrotask(()=>$6e21d5af8b0e2b63$var$mutateDom(()=>el.removeAttribute($6e21d5af8b0e2b63$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$6e21d5af8b0e2b63$var$addInitSelector(()=>`[${$6e21d5af8b0e2b63$var$prefix("init")}]`);
$6e21d5af8b0e2b63$var$directive("init", $6e21d5af8b0e2b63$var$skipDuringClone((el, { expression: expression  }, { evaluate: evaluate2  })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$6e21d5af8b0e2b63$var$directive("text", (el, { expression: expression  }, { effect: effect3 , evaluateLater: evaluateLater2  })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $6e21d5af8b0e2b63$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$6e21d5af8b0e2b63$var$directive("html", (el, { expression: expression  }, { effect: effect3 , evaluateLater: evaluateLater2  })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $6e21d5af8b0e2b63$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $6e21d5af8b0e2b63$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$6e21d5af8b0e2b63$var$mapAttributes($6e21d5af8b0e2b63$var$startingWith(":", $6e21d5af8b0e2b63$var$into($6e21d5af8b0e2b63$var$prefix("bind:"))));
$6e21d5af8b0e2b63$var$directive("bind", (el, { value: value , modifiers: modifiers , expression: expression , original: original  }, { effect: effect3  })=>{
    if (!value) {
        let bindingProviders = {};
        $6e21d5af8b0e2b63$var$injectBindingProviders(bindingProviders);
        let getBindings = $6e21d5af8b0e2b63$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $6e21d5af8b0e2b63$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $6e21d5af8b0e2b63$var$storeKeyForXFor(el, expression);
    let evaluate2 = $6e21d5af8b0e2b63$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $6e21d5af8b0e2b63$var$mutateDom(()=>$6e21d5af8b0e2b63$var$bind(el, value, result, modifiers));
        }));
});
function $6e21d5af8b0e2b63$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$6e21d5af8b0e2b63$var$addRootSelector(()=>`[${$6e21d5af8b0e2b63$var$prefix("data")}]`);
$6e21d5af8b0e2b63$var$directive("data", $6e21d5af8b0e2b63$var$skipDuringClone((el, { expression: expression  }, { cleanup: cleanup2  })=>{
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $6e21d5af8b0e2b63$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $6e21d5af8b0e2b63$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $6e21d5af8b0e2b63$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $6e21d5af8b0e2b63$var$injectMagics(data2, el);
    let reactiveData = $6e21d5af8b0e2b63$var$reactive(data2);
    $6e21d5af8b0e2b63$var$initInterceptors(reactiveData);
    let undo = $6e21d5af8b0e2b63$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $6e21d5af8b0e2b63$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $6e21d5af8b0e2b63$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
}));
// packages/alpinejs/src/directives/x-show.js
$6e21d5af8b0e2b63$var$directive("show", (el, { modifiers: modifiers , expression: expression  }, { effect: effect3  })=>{
    let evaluate2 = $6e21d5af8b0e2b63$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $6e21d5af8b0e2b63$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $6e21d5af8b0e2b63$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $6e21d5af8b0e2b63$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$6e21d5af8b0e2b63$var$directive("for", (el, { expression: expression  }, { effect: effect3 , cleanup: cleanup2  })=>{
    let iteratorNames = $6e21d5af8b0e2b63$var$parseForExpression(expression);
    let evaluateItems = $6e21d5af8b0e2b63$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $6e21d5af8b0e2b63$var$evaluateLater(el, el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$6e21d5af8b0e2b63$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $6e21d5af8b0e2b63$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($6e21d5af8b0e2b63$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $6e21d5af8b0e2b63$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $6e21d5af8b0e2b63$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($6e21d5af8b0e2b63$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $6e21d5af8b0e2b63$var$mutateDom(()=>{
                if (!elForSpot) $6e21d5af8b0e2b63$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $6e21d5af8b0e2b63$var$reactive(scope2);
            $6e21d5af8b0e2b63$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $6e21d5af8b0e2b63$var$mutateDom(()=>{
                lastEl.after(clone2);
                $6e21d5af8b0e2b63$var$initTree(clone2);
            });
            if (typeof key === "object") $6e21d5af8b0e2b63$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $6e21d5af8b0e2b63$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $6e21d5af8b0e2b63$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $6e21d5af8b0e2b63$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $6e21d5af8b0e2b63$var$handler2() {}
$6e21d5af8b0e2b63$var$handler2.inline = (el, { expression: expression  }, { cleanup: cleanup2  })=>{
    let root = $6e21d5af8b0e2b63$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$6e21d5af8b0e2b63$var$directive("ref", $6e21d5af8b0e2b63$var$handler2);
// packages/alpinejs/src/directives/x-if.js
$6e21d5af8b0e2b63$var$directive("if", (el, { expression: expression  }, { effect: effect3 , cleanup: cleanup2  })=>{
    let evaluate2 = $6e21d5af8b0e2b63$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $6e21d5af8b0e2b63$var$addScopeToNode(clone2, {}, el);
        $6e21d5af8b0e2b63$var$mutateDom(()=>{
            el.after(clone2);
            $6e21d5af8b0e2b63$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $6e21d5af8b0e2b63$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($6e21d5af8b0e2b63$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$6e21d5af8b0e2b63$var$directive("id", (el, { expression: expression  }, { evaluate: evaluate2  })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$6e21d5af8b0e2b63$var$setIdRoot(el, name));
});
// packages/alpinejs/src/directives/x-on.js
$6e21d5af8b0e2b63$var$mapAttributes($6e21d5af8b0e2b63$var$startingWith("@", $6e21d5af8b0e2b63$var$into($6e21d5af8b0e2b63$var$prefix("on:"))));
$6e21d5af8b0e2b63$var$directive("on", $6e21d5af8b0e2b63$var$skipDuringClone((el, { value: value , modifiers: modifiers , expression: expression  }, { cleanup: cleanup2  })=>{
    let evaluate2 = expression ? $6e21d5af8b0e2b63$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $6e21d5af8b0e2b63$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                $event: e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$6e21d5af8b0e2b63$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$6e21d5af8b0e2b63$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$6e21d5af8b0e2b63$var$warnMissingPluginDirective("Focus", "trap", "focus");
$6e21d5af8b0e2b63$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $6e21d5af8b0e2b63$var$warnMissingPluginDirective(name, directiveName2, slug) {
    $6e21d5af8b0e2b63$var$directive(directiveName2, (el)=>$6e21d5af8b0e2b63$var$warn(`You can't use [x-${directiveName2}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$6e21d5af8b0e2b63$var$alpine_default.setEvaluator($6e21d5af8b0e2b63$var$normalEvaluator);
$6e21d5af8b0e2b63$var$alpine_default.setReactivityEngine({
    reactive: $6e21d5af8b0e2b63$var$reactive2,
    effect: $6e21d5af8b0e2b63$var$effect2,
    release: $6e21d5af8b0e2b63$var$stop,
    raw: $6e21d5af8b0e2b63$var$toRaw
});
var $6e21d5af8b0e2b63$var$src_default = $6e21d5af8b0e2b63$var$alpine_default;
// packages/alpinejs/builds/module.js
var $6e21d5af8b0e2b63$export$2e2bcd8739ae039 = $6e21d5af8b0e2b63$var$src_default;


// packages/intersect/src/index.js
function $4f9937ee889e09a7$var$src_default(Alpine) {
    Alpine.directive("intersect", (el, { value: value , expression: expression , modifiers: modifiers  }, { evaluateLater: evaluateLater , cleanup: cleanup  })=>{
        let evaluate = evaluateLater(expression);
        let options = {
            rootMargin: $4f9937ee889e09a7$var$getRootMargin(modifiers),
            threshold: $4f9937ee889e09a7$var$getThreshhold(modifiers)
        };
        let observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting === (value === "leave")) return;
                evaluate();
                modifiers.includes("once") && observer.disconnect();
            });
        }, options);
        observer.observe(el);
        cleanup(()=>{
            observer.disconnect();
        });
    });
}
function $4f9937ee889e09a7$var$getThreshhold(modifiers) {
    if (modifiers.includes("full")) return 0.99;
    if (modifiers.includes("half")) return 0.5;
    if (!modifiers.includes("threshold")) return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100") return 1;
    if (threshold === "0") return 0;
    return Number(`.${threshold}`);
}
function $4f9937ee889e09a7$var$getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
}
function $4f9937ee889e09a7$var$getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1) return fallback;
    let values = [];
    for(let i = 1; i < 5; i++)values.push($4f9937ee889e09a7$var$getLengthValue(modifiers[index + i] || ""));
    values = values.filter((v)=>v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
}
// packages/intersect/builds/module.js
var $4f9937ee889e09a7$export$2e2bcd8739ae039 = $4f9937ee889e09a7$var$src_default;




var $bwojW = parcelRequire("bwojW");
var $4qnBj = parcelRequire("4qnBj");
var $56cRO = parcelRequire("56cRO");

var $ck5Qh = parcelRequire("ck5Qh");

var $5sHEg = parcelRequire("5sHEg");
var $dNL5b = parcelRequire("dNL5b");
var $2g4we = parcelRequire("2g4we");
var $eup42 = parcelRequire("eup42");
var $geNSS = parcelRequire("geNSS");

var $4qnBj = parcelRequire("4qnBj");

var $44w9N = parcelRequire("44w9N");

var $et9TO = parcelRequire("et9TO");

var $kG62X = parcelRequire("kG62X");

var $inIS9 = parcelRequire("inIS9");

var $kqd0U = parcelRequire("kqd0U");

var $50VeR = parcelRequire("50VeR");
function $59249da1a42500d8$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if ((0, $50VeR.isNumber)(next)) return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}



var $2BiSR = parcelRequire("2BiSR");
var $uRDjj = parcelRequire("uRDjj");
var $hsXm3 = parcelRequire("hsXm3");
function $fb35f372ff0b7efe$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $hsXm3.removeItem)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $fb35f372ff0b7efe$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $fb35f372ff0b7efe$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $uRDjj.mix)(startTime, endTime, offset[i]),
        easing: (0, $2BiSR.getEasingForSegment)(easing, i)
    });
}


function $f2c8ddf03f7e41cd$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) return a.value === null ? 1 : -1;
    else return a.at - b.at;
}



var $5dQbc = parcelRequire("5dQbc");
function $96e715620571c79a$export$cddc5598d4bb8461(definition, options = {}) {
    var _a;
    const animationDefinitions = $96e715620571c79a$export$ecf4a6d05c8cfe84(definition, options);
    /**
     * Create and start animations
     */ const animationFactories = animationDefinitions.map((definition)=>(0, $44w9N.animateStyle)(...definition, (0, $5dQbc.Animation))).filter(Boolean);
    return (0, $et9TO.withControls)(animationFactories, options, // Get the duration from the first animation definition
    (_a = animationDefinitions[0]) === null || _a === void 0 ? void 0 : _a[3].duration);
}
function $96e715620571c79a$export$ecf4a6d05c8cfe84(definition, _a = {}) {
    var { defaultOptions: defaultOptions = {}  } = _a, timelineOptions = (0, $56cRO.__rest)(_a, [
        "defaultOptions"
    ]);
    const animationDefinitions = [];
    const elementSequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the definition array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < definition.length; i++){
        const segment = definition[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if ((0, $eup42.isString)(segment)) {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $59249da1a42500d8$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        const [elementDefinition, keyframes, options = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (options.at !== undefined) currentTime = (0, $59249da1a42500d8$export$83ccd85155ba9791)(currentTime, options.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        /**
         * Find all the elements specified in the definition and parse value
         * keyframes from their timeline definitions.
         */ const elements = (0, $kqd0U.resolveElements)(elementDefinition, elementCache);
        const numElements = elements.length;
        for(let elementIndex = 0; elementIndex < numElements; elementIndex++){
            const element = elements[elementIndex];
            const elementSequence = $96e715620571c79a$var$getElementSequence(element, elementSequences);
            for(const key in keyframes){
                const valueSequence = $96e715620571c79a$var$getValueSequence(key, elementSequence);
                let valueKeyframes = (0, $kG62X.keyframesList)(keyframes[key]);
                const valueOptions = (0, $inIS9.getOptions)(options, key);
                let { duration: duration = defaultOptions.duration || (0, $dNL5b.defaults).duration , easing: easing = defaultOptions.easing || (0, $dNL5b.defaults).easing  } = valueOptions;
                if ((0, $2g4we.isEasingGenerator)(easing)) {
                    (0, $ck5Qh.invariant)(key === "opacity" || valueKeyframes.length > 1, "spring must be provided 2 keyframes within timeline()");
                    const custom = easing.createAnimation(valueKeyframes, key !== "opacity", ()=>0, key);
                    easing = custom.easing;
                    valueKeyframes = custom.keyframes || valueKeyframes;
                    duration = custom.duration || duration;
                }
                const delay = (0, $4qnBj.resolveOption)(options.delay, elementIndex, numElements) || 0;
                const startTime = currentTime + delay;
                const targetTime = startTime + duration;
                /**
                 *
                 */ let { offset: offset = (0, $5sHEg.defaultOffset)(valueKeyframes.length)  } = valueOptions;
                /**
                 * If there's only one offset of 0, fill in a second with length 1
                 *
                 * TODO: Ensure there's a test that covers this removal
                 */ if (offset.length === 1 && offset[0] === 0) offset[1] = 1;
                /**
                 * Fill out if offset if fewer offsets than keyframes
                 */ const remainder = offset.length - valueKeyframes.length;
                remainder > 0 && (0, $5sHEg.fillOffset)(offset, remainder);
                /**
                 * If only one value has been set, ie [1], push a null to the start of
                 * the keyframe array. This will let us mark a keyframe at this point
                 * that will later be hydrated with the previous value.
                 */ valueKeyframes.length === 1 && valueKeyframes.unshift(null);
                /**
                 * Add keyframes, mapping offsets to absolute time.
                 */ (0, $fb35f372ff0b7efe$export$89dfa6760a9f76e7)(valueSequence, valueKeyframes, easing, offset, startTime, targetTime);
                maxDuration = Math.max(delay + duration, maxDuration);
                totalDuration = Math.max(targetTime, totalDuration);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ elementSequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $f2c8ddf03f7e41cd$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at , value: value , easing: easing  } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $geNSS.progress)(0, totalDuration, at));
                valueEasing.push(easing || (0, $dNL5b.defaults).easing);
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift("linear");
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            animationDefinitions.push([
                element,
                key,
                keyframes,
                Object.assign(Object.assign(Object.assign({}, defaultOptions), {
                    duration: totalDuration,
                    easing: valueEasing,
                    offset: valueOffset
                }), timelineOptions)
            ]);
        }
    });
    return animationDefinitions;
}
function $96e715620571c79a$var$getElementSequence(element, sequences) {
    !sequences.has(element) && sequences.set(element, {});
    return sequences.get(element);
}
function $96e715620571c79a$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}


const $a109bf773e58a1a9$var$Navi = ()=>{
    const navEl = document.querySelector(".nav");
    const navItemEls = document.querySelectorAll(".nav-item");
    const secondaryNavEls = document.querySelectorAll(".secondary-nav");
    const siteLogoEl = document.querySelector(".site-logo");
    const marquee = navEl.querySelector(".nav-marquee");
    const transition = 100;
    if (!navEl) return;
    document.addEventListener("nav:toggle", (e)=>{
        if (e.detail) // open
        openNav();
        else // close
        closeNav();
    });
    const openNav = ()=>{
        siteLogoEl.classList.add("nav-open");
        (0, $96e715620571c79a$export$cddc5598d4bb8461)([
            [
                navEl,
                {
                    x: 0
                },
                {
                    duration: 0.5,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                }
            ],
            [
                navItemEls,
                {
                    y: 0,
                    opacity: 1
                },
                {
                    duration: 0.5,
                    delay: (0, $4qnBj.stagger)(0.1),
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                }
            ],
            [
                siteLogoEl,
                {
                    rotate: "360deg",
                    filter: "brightness(255)"
                },
                {
                    duration: 0.5,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ],
                    at: "-0.75"
                }
            ],
            [
                secondaryNavEls,
                {
                    y: 0,
                    opacity: 1
                },
                {
                    duration: 0.5,
                    delay: (0, $4qnBj.stagger)(0.1),
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ],
                    at: "-0.5"
                }
            ]
        ]);
    };
    const closeNav = (duration = 0.5)=>{
        siteLogoEl.classList.remove("nav-open");
        (0, $96e715620571c79a$export$cddc5598d4bb8461)([
            [
                siteLogoEl,
                {
                    filter: "brightness(1)"
                },
                {
                    duration: 0,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ],
                    at: "<"
                }
            ],
            [
                navEl,
                {
                    x: "100%"
                },
                {
                    duration: duration,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                }
            ],
            [
                siteLogoEl,
                {
                    rotate: "-1080deg"
                },
                {
                    duration: (duration > 0) ?? 20,
                    easing: [
                        0,
                        1,
                        1,
                        1
                    ],
                    at: "<"
                }
            ],
            [
                navItemEls,
                {
                    opacity: 0,
                    y: "30px"
                },
                {
                    duration: duration,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                }
            ],
            [
                secondaryNavEls,
                {
                    opacity: 0,
                    y: "30px"
                },
                {
                    duration: duration,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ],
                    at: "<"
                }
            ]
        ]).finished.then(()=>{
            (0, $bwojW.animate)(siteLogoEl, {
                rotate: "0deg"
            }, {
                duration: 0
            });
        });
    };
    closeNav(0);
    const insertMarquee = (text)=>{
        const marq = document.createElement("div");
        marq.classList.add("flex", "custom-marquee");
        marq.setAttribute("scrollamount", 60);
        const span = document.createElement("span");
        span.classList.add("inline-block");
        span.innerText = text;
        for(let i = 0; i < 20; i++)marq.appendChild(span.cloneNode(true));
        marq.addEventListener("animationend", (e)=>{
            if (e.animationName === "custom-marquee-in") {
                marquee.classList.remove("in");
                marquee.classList.add("loop");
            }
        });
        marquee.classList.add("in");
        marquee.appendChild(marq);
    };
    const replaceMarqueeText = (text)=>{
        const marqueeChildren = marquee.querySelectorAll("span");
        marqueeChildren.forEach((el)=>{
            el.style.transition = `opacity ${transition}ms`;
            el.style.opacity = 0;
            setTimeout((_)=>{
                el.innerHTML = text;
                el.style.opacity = 1;
            }, transition);
        });
    };
    document.addEventListener("marquee:start", (e)=>{
        const marqueeChildren = marquee.querySelectorAll("span");
        if (marqueeChildren && marqueeChildren.length) // console.log('is hover');
        replaceMarqueeText(e.detail);
        else // console.log('is new hover');
        insertMarquee(e.detail);
    });
    document.addEventListener("marquee:end", ()=>{
        marquee.style.transition = `opacity ${transition}ms`;
        marquee.style.opacity = 0;
        setTimeout((_)=>{
            marquee.innerHTML = "";
            marquee.style.opacity = 1;
        }, transition);
    });
};
var $a109bf773e58a1a9$export$2e2bcd8739ae039 = $a109bf773e58a1a9$var$Navi;


(0, $6e21d5af8b0e2b63$export$2e2bcd8739ae039).plugin((0, $4f9937ee889e09a7$export$2e2bcd8739ae039));
window.Alpine = (0, $6e21d5af8b0e2b63$export$2e2bcd8739ae039);
(0, $6e21d5af8b0e2b63$export$2e2bcd8739ae039).start();











const $200467ff3b1f5c11$var$domReady = ()=>{
    (0, $a109bf773e58a1a9$export$2e2bcd8739ae039)();
    const banner = document.querySelectorAll(".banner");
    const fullImageBanner = document.querySelectorAll(".full-image-banner");
    const simpleHeader = document.querySelectorAll(".simple-header");
    const heroMarquee = document.querySelectorAll(".hero-marquee");
    const marquee = document.querySelectorAll(".marquee");
    const inlineForm = document.querySelectorAll(".inline-form");
    const fixedScrolls = document.querySelectorAll(".fixed-scroll");
    const stickyStats = document.querySelectorAll(".sticky-stats");
    const numberCounter = document.querySelectorAll(".countup");
    let transitionableBlocks = document.querySelectorAll(".transition-block");
    const forms = document.querySelectorAll(".gform_wrapper form");
    const carousels = document.querySelectorAll(".carousel");
    const projectSliders = document.querySelectorAll(".project-slider");
    if (banner.length) (parcelRequire("dmkYV")).then(({ default: Banner  })=>{
        Banner();
    });
    if (fullImageBanner.length) (parcelRequire("dR8tM")).then(({ default: FullImageBanner  })=>{
        FullImageBanner();
    });
    if (simpleHeader.length) (parcelRequire("2yi0A")).then(({ default: SimpleHeader  })=>{
        SimpleHeader();
    });
    if (heroMarquee.length) (parcelRequire("1aKZv")).then(({ default: Hero  })=>{
        Hero();
    });
    if (marquee.length) (parcelRequire("18V4F")).then(({ default: Marquee  })=>{
        Marquee();
    });
    if (numberCounter.length) (parcelRequire("eL3hJ")).then(({ default: Countup  })=>{
        Countup();
    });
    if (fixedScrolls.length) (parcelRequire("coHQp")).then(({ default: FixedScroll  })=>{
        FixedScroll();
    });
    if (stickyStats.length) (parcelRequire("8yGKq")).then(({ default: stickyStats  })=>{
        stickyStats();
    });
    if (forms.length) (parcelRequire("2TxWE")).then(({ default: fileUploadElement  })=>{
        forms.forEach((form)=>{
            fileUploadElement(form);
        });
    });
    if (carousels.length) (parcelRequire("9FRWQ")).then(({ default: Carousel  })=>{
        Carousel();
    });
    if (projectSliders.length) (parcelRequire("cc94P")).then(({ default: ProjectSlider  })=>{
        ProjectSlider();
    });
    let inViewStop = (0, $8KJLc.inView)(transitionableBlocks, ({ target: target  })=>{
        target.classList.add("is-visible");
        //animate(
        //  target,
        //  { opacity: 1, transform: 'none' },
        //  { delay: 0.2, duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
        //);
        return ()=>{
            target.classList.remove("is-visible");
        //animate(
        //  target,
        //  { transform: 'translateY(60px)' },
        //  { duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
        //);
        };
    });
    document.addEventListener("block:load", ()=>{
        transitionableBlocks = document.querySelectorAll(".transition-block");
        transitionBlocks = document.querySelectorAll(".transition");
        inViewStop();
        inViewStop = (0, $8KJLc.inView)(transitionableBlocks, ({ target: target  })=>{
            target.classList.add("is-visible");
            //animate(
            //  target,
            //  { opactiy: 1, transform: 'none' },
            //  { delay: 0.2, duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
            //);
            return ()=>{
                target.classList.remove("is-visible");
            //animate(
            //  target,
            //  { transform: 'translateY(60px)' },
            //  { duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
            //);
            };
        });
    });
};
document.addEventListener("DOMContentLoaded", $200467ff3b1f5c11$var$domReady);

})();
//# sourceMappingURL=main.js.map
